var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g3, _g4, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _g5, _g6, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameSideL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 805,
    height: 1296,
    viewBox: "0 0 805 1296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-354.988 -388.12L-235.856 -343.424L-109.615 -396.242L-24.78 -363.8L14.5056 -253.391L290.04 -149.186L387.079 -189.787L477.731 -155.503L480.295 -159.901L387.257 -195.087L290.218 -154.487L18.8587 -257.113L-20.4268 -367.522L-109.289 -401.129L-235.531 -348.311L-352.571 -392.932L-354.988 -388.12Z",
    fill: "url(#paint0_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.823 -80.5002L439.5 -8.73559L489.714 -29.7536L627.276 22.2931L629.276 17.5927L490.045 -34.7214L439.831 -13.7034L253.789 -84.0924L197.425 -242.565L23.5036 -308.369L-15.6672 -418.501L-226.405 -497.87L-279.815 -475.515L-314.506 -489.004L-317.112 -484.533L-280.146 -470.547L-226.736 -492.902L-19.9409 -414.298L19.0803 -304.586L193.608 -238.553L249.823 -80.5002Z",
    fill: "url(#paint1_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-251.717 36.2786L-177.472 63.4137L-62.7738 16.4546L34.2797 52.3718L358.237 -80.2608L437.274 -51.0108L439.335 -55.0256L358.554 -84.9208L34.5969 47.7119L-62.0187 11.6154L-177.155 58.7537L-249.362 31.6903L-251.717 36.2786Z",
    fill: "url(#paint2_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-244.131 -265.616L-132.331 -223.293L-64.4127 -251.736L181.429 -158.672L185.543 -167.584L-63.4518 -262.203L-131.37 -233.76L-235.958 -273.352L-264.133 -352.614L-363.311 -390.158L-368.027 -381.474L-272.307 -344.877L-244.131 -265.616Z",
    fill: "url(#paint3_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-82.841 -109.257L97.2547 -41.1675L99.2621 -45.8832L-78.8583 -112.861L-106.02 -190.652L-300.718 -264.262L-318.58 -314.449L-393.876 -342.551L-396.033 -338.257L-323.022 -310.653L-305.159 -260.467L-110.461 -186.856L-82.841 -109.257Z",
    fill: "url(#paint4_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-244.541 -55.2406L-165.967 -25.4989L87.0532 -131.452L195.617 -90.3585L235.275 21.1929L499.187 121.088L521.236 183.108L584.815 207.173L589.068 198.697L529.54 175.805L506.892 113.558L242.98 13.6628L203.322 -97.8887L87.5604 -141.706L-165.008 -35.9428L-236.385 -62.96L-253.994 -112.492L-449.077 -186.695L-453.635 -177.613L-262.299 -105.189L-244.541 -55.2406Z",
    fill: "url(#paint5_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.15 -43.5761L151.06 65.4357L350.185 -17.8867L503.539 40.1175L508.073 31.0894L351.139 -28.2689L151.564 55.2415L-129.035 -51.25L-159.509 -136.903L-422.657 -236.436L-427.191 -227.408L-167.623 -129.229L-137.15 -43.5761Z",
    fill: "url(#paint6_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.647 251.612L562.105 289.569L564.574 284.656L467.094 247.813L434.327 155.779L243.022 83.4732L240.403 87.9637L429.88 159.579L462.647 251.612Z",
    fill: "url(#paint7_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-486.288 68.0735L-152.605 194.176L-9.67561 134.42L161.032 198.932L261.845 156.784L329.652 182.409L332.209 178.026L262.617 151.727L161.357 194.062L-9.35076 129.549L-151.833 189.118L-482.541 64.1397L-512.037 -18.6935L-533.449 -26.7856L-535.412 -22.1775L-515.93 -15.1718L-486.288 68.0735Z",
    fill: "url(#paint8_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-479.185 220.631L-198.338 326.7L-154.506 308.386L-1.31684 366.242L298.801 240.846L567.772 342.43L587.548 397.932L592.468 395.877L571.96 338.319L299.426 235.389L-1.13922 360.972L-153.734 303.34L-197.567 321.654L-475.444 216.706L-486.138 186.694L-596.129 144.797L-598.535 149.581L-490.025 190.207L-479.185 220.631Z",
    fill: "url(#paint9_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.998 217.339L346.373 306.641L348.538 302.336L112.845 213.303L70.5222 93.0139L-240.886 -24.6205L-289.544 -161.209L-442.195 -218.873L-444.21 -214.144L-294.001 -157.403L-245.343 -20.8145L66.0652 96.8199L108.998 217.339Z",
    fill: "url(#paint10_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.157 295.826C550.723 300.676 552.649 306.095 557.454 307.914C562.259 309.733 568.141 307.27 570.575 302.419C573.009 297.569 571.083 292.15 566.129 289.914C561.324 288.095 555.443 290.558 553.009 295.409L553.157 295.826Z",
    fill: "url(#paint11_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.731 69.7734C230.297 74.624 232.223 80.043 237.028 81.8619C241.833 83.6808 247.715 81.2176 250.149 76.367C252.583 71.5164 250.657 66.0975 245.704 63.8617C240.899 62.0428 235.017 64.506 232.583 69.3566L232.731 69.7734Z",
    fill: "url(#paint12_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.893 209.514C318.461 214.36 320.386 219.774 325.187 221.591C329.987 223.409 335.864 220.948 338.296 216.102C340.728 211.256 338.803 205.842 334.002 204.025C329.202 202.208 323.325 204.668 320.893 209.514Z",
    fill: "url(#paint13_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.887 255.368C279.453 260.219 281.379 265.638 286.184 267.457C290.989 269.276 296.871 266.813 299.305 261.962C301.74 257.111 299.813 251.692 294.86 249.457C290.055 247.638 284.173 250.101 281.739 254.951L281.887 255.368Z",
    fill: "url(#paint14_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.8079 136.391C-19.2398 141.237 -17.3152 146.651 -12.5145 148.468C-7.71383 150.285 -1.83749 147.825 0.594427 142.979C3.02634 138.133 1.10174 132.719 -3.69893 130.902C-8.49961 129.085 -14.376 131.545 -16.8079 136.391Z",
    fill: "url(#paint15_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.027 441.803C580.598 446.643 582.52 452.049 587.315 453.864C592.109 455.679 597.979 453.221 600.859 448.193C603.739 443.164 601.366 437.947 596.571 436.132C591.776 434.317 585.907 436.775 583.478 441.614L583.027 441.803Z",
    fill: "url(#paint16_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.678 330.617C335.247 335.463 337.171 340.877 341.972 342.694C346.773 344.511 352.649 342.05 355.081 337.204C357.513 332.358 355.588 326.944 350.787 325.127C345.987 323.31 340.11 325.771 337.678 330.617Z",
    fill: "url(#paint17_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6814 100.676C55.2517 105.517 57.1746 110.925 61.9709 112.741C66.7673 114.556 72.6386 112.098 75.52 107.067C77.9497 102.226 76.0268 96.8175 71.2304 95.0021C66.4341 93.1866 60.5629 95.6451 58.1331 100.486L57.6814 100.676Z",
    fill: "url(#paint18_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.098 53.0974C614.666 57.9433 616.591 63.3571 621.392 65.1743C626.192 66.9915 632.069 64.5306 634.501 59.6847C636.933 54.8387 635.008 49.4249 630.207 47.6077C625.407 45.7905 619.53 48.2514 617.098 53.0974Z",
    fill: "url(#paint19_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.717 67.3335C489.07 74.6007 491.734 82.0949 498.934 84.82C506.133 87.5451 514.268 84.1386 517.915 76.8715C521.562 69.6044 518.897 62.1102 511.698 59.385C504.499 56.6599 496.512 60.4828 492.717 67.3335Z",
    fill: "url(#paint20_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.454 241.509C571.802 248.787 574.922 256.102 581.679 259.021C588.436 261.939 597.034 258.338 600.233 251.25C603.581 244.579 600.765 236.657 594.008 233.739C587.4 231.237 578.653 234.421 575.001 241.699L575.454 241.509Z",
    fill: "url(#paint21_linear_78_5692)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-233.347 -284.056L-145.224 -251.086L-52.2246 -289.997L10.9956 -266.087L39.9828 -184.62L243.508 -107.29L315.392 -137.366L382.787 -111.877L384.15 -115.298L315.563 -141.238L244.128 -111.35L43.1354 -187.365L14.0012 -269.245L-51.6046 -294.057L-145.054 -254.958L-231.534 -287.665L-233.347 -284.056Z",
    fill: "url(#paint22_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.737 -56.7996L354.329 -3.60636L391.306 -19.0833L492.965 19.0156L494.5 15.9586L391.479 -23.0194L354.503 -7.54238L216.94 -59.5893L175.377 -176.448L46.2982 -225.285L17.4432 -306.414L-138.3 -365.339L-177.558 -348.907L-203.617 -358.766L-205.151 -355.709L-177.732 -344.971L-138.623 -361.823L14.6962 -303.815L43.2443 -222.075L172.173 -173.658L213.737 -56.7996Z",
    fill: "url(#paint23_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-156.972 29.6379L-101.908 49.6729L-16.8397 15.3006L54.6392 41.751L294.093 -56.2762L352.644 -34.9511L354.115 -37.8183L294.259 -59.9679L54.8054 38.0594L-16.6735 11.6089L-101.599 46.3754L-155.062 26.5914L-156.972 29.6379Z",
    fill: "url(#paint24_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-151.415 -193.594L-68.4719 -162.196L-18.2163 -183.242L163.296 -114.53L166.645 -121.204L-17.8723 -191.054L-68.1278 -170.007L-145.208 -199.548L-165.968 -257.947L-239.747 -285.515L-243.244 -279.258L-172.322 -252.41L-151.415 -193.594Z",
    fill: "url(#paint25_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32.1039 -77.8379L100.983 -27.8852L102.524 -30.9522L-28.888 -80.6365L-49.301 -137.989L-193.489 -192.504L-206.697 -229.614L-262.061 -250.546L-264.06 -247.287L-209.455 -227.007L-196.247 -189.897L-52.517 -135.19L-32.1039 -77.8379Z",
    fill: "url(#paint26_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-151.787 -37.9575L-93.6071 -15.9356L93.4435 -94.2633L173.667 -64.2575L203.114 18.5718L398.045 92.3565L414.47 138.558L461.705 156.077L465.047 149.417L420.811 133.033L404.386 86.832L209.003 13.2364L179.556 -69.5929L93.7868 -102.058L-92.812 -23.9196L-145.445 -43.482L-158.615 -80.5263L-303.164 -135.24L-306.506 -128.581L-164.956 -75.0017L-151.787 -37.9575Z",
    fill: "url(#paint27_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-72.2059 -29.4584L140.816 51.1142L288.247 -10.5772L401.62 32.3046L404.945 25.6841L288.736 -17.9123L141.304 43.779L-66.3468 -34.7623L-89.0175 -98.4839L-283.542 -172.06L-286.867 -165.439L-94.7294 -92.7662L-72.2059 -29.4584Z",
    fill: "url(#paint28_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.227 189.096L444.943 216.958L446.795 213.274L374.447 186.294L350.098 117.904L208.757 64.4828L206.906 68.1671L347.028 121.128L371.227 189.096Z",
    fill: "url(#paint29_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-330.69 52.9725L-83.7048 146.667L22.0351 102.46L148.131 150.113L222.955 118.83L272.918 137.711L274.872 134.527L223.126 114.971L148.301 146.254L22.2052 98.601L-83.0865 142.621L-327.546 50.2376L-349.264 -10.7529L-365.323 -16.8219L-366.683 -13.4127L-352.408 -8.01809L-330.69 52.9725Z",
    fill: "url(#paint30_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325.308 165.881L-117.348 244.779L-85.1442 231.324L28.1162 273.744L250.408 180.866L449.316 255.988L463.964 297.101L467.095 295.793L452.007 253.447L250.578 177.016L28.2861 269.894L-84.527 227.287L-117.178 240.929L-322.616 163.34L-330.527 141.139L-411.871 110.417L-413.375 113.407L-333.218 143.681L-325.308 165.881Z",
    fill: "url(#paint31_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.591 163.404L285.447 229.833L286.843 226.335L112.819 160.597L81.1834 71.793L-149.017 -15.1649L-185.021 -116.233L-297.524 -159.097L-299.38 -155.406L-188.249 -113.426L-152.245 -12.3585L77.9555 74.5994L109.591 163.404Z",
    fill: "url(#paint32_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.095 221.477C436.272 225.111 437.752 229.276 441.353 230.639C444.953 232.002 449.473 230.109 451.297 226.474C453.121 222.84 451.641 218.675 448.04 217.312C444.44 215.949 439.919 217.842 438.095 221.477Z",
    fill: "url(#paint33_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.203 54.416C199.379 58.0505 200.859 62.215 204.46 63.5779C208.06 64.9408 212.581 63.0478 214.405 59.4134C216.229 55.7789 214.748 51.6144 211.148 50.2515C207.547 48.8886 203.027 50.7816 201.203 54.416Z",
    fill: "url(#paint34_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.433 157.902C264.61 161.537 266.09 165.701 269.69 167.064C273.291 168.427 277.811 166.534 279.635 162.9C281.459 159.265 279.979 155.101 276.378 153.738C272.778 152.375 268.257 154.268 266.433 157.902Z",
    fill: "url(#paint35_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.601 191.767C235.777 195.402 237.258 199.566 240.858 200.929C244.459 202.292 248.979 200.399 250.803 196.765C252.627 193.13 251.147 188.966 247.546 187.603C243.946 186.24 239.425 188.133 237.601 191.767Z",
    fill: "url(#paint36_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4823 103.68C14.6583 107.315 16.1388 111.479 19.7393 112.842C23.3398 114.205 27.8601 112.312 29.684 108.678C31.508 105.043 30.0275 100.879 26.427 99.5159C22.8265 98.153 18.3062 100.046 16.4823 103.68Z",
    fill: "url(#paint37_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.318 329.859C458.494 333.494 459.975 337.658 463.575 339.021C467.176 340.384 471.696 338.491 473.52 334.856C475.344 331.222 473.863 327.057 470.263 325.694C466.662 324.332 462.142 326.225 460.318 329.859Z",
    fill: "url(#paint38_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.004 247.724C277.18 251.359 278.66 255.523 282.261 256.886C285.861 258.249 290.382 256.356 292.206 252.722C294.029 249.087 292.549 244.923 288.948 243.56C285.348 242.197 280.828 244.09 279.004 247.724Z",
    fill: "url(#paint39_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9001 77.3086C70.0762 80.9431 71.5566 85.1075 75.1571 86.4704C78.7576 87.8333 83.278 85.9403 85.102 82.3059C86.9259 78.6714 85.4454 74.507 81.8449 73.1441C78.2444 71.7812 73.724 73.6742 71.9001 77.3086Z",
    fill: "url(#paint40_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.644 42.2276C483.82 45.862 485.301 50.0266 488.901 51.3895C492.502 52.7524 497.022 50.8594 498.846 47.2249C500.67 43.5904 499.19 39.4259 495.589 38.063C491.989 36.7001 487.468 38.5931 485.644 42.2276Z",
    fill: "url(#paint41_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.374 52.6255C390.641 58.0697 392.564 63.4761 397.958 65.5177C403.204 67.1433 409.072 64.6859 411.953 59.6576C414.833 54.6292 412.763 48.8069 407.369 46.7654C402.575 44.9507 396.254 47.5972 393.374 52.6255Z",
    fill: "url(#paint42_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.005 181.28C452.573 186.124 454.645 191.952 459.593 194.185C464.392 196.002 470.718 193.353 473.601 188.319C476.484 183.285 474.412 177.457 469.013 175.414C464.214 173.597 457.74 175.83 455.005 181.28Z",
    fill: "url(#paint43_linear_78_5692)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-189.566 -246.787L-112.63 -217.69L-31.3128 -251.712L23.5564 -230.961L49.0116 -159.421L226.593 -92.6184L289.491 -118.934L348.085 -96.4161L349.596 -99.4235L289.955 -121.979L227.058 -95.6634L51.715 -161.977L26.2598 -233.518L-30.9951 -255.171L-112.312 -221.148L-188.056 -249.794L-189.566 -246.787Z",
    fill: "url(#paint44_linear_78_5692)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.031 -48.2179L323.446 -1.9024L355.858 -15.4688L444.485 18.4272L446.02 15.37L356.33 -18.5642L323.919 -4.99774L203.471 -50.205L166.991 -152.773L54.8783 -195.191L29.611 -266.232L-106.593 -317.401L-140.98 -303.49L-163.402 -311.974L-164.937 -308.917L-141.303 -299.975L-107.065 -314.305L26.8641 -263.633L52.1313 -192.592L164.7 -150.366L201.031 -48.2179Z",
    fill: "url(#paint45_linear_78_5692)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-122.642 27.2153L-74.9855 44.8526L-0.998624 14.56L61.768 37.7896L271.032 -47.8901L322.176 -28.9622L323.21 -31.6509L271.342 -51.1882L62.0778 34.4914L-0.545601 11.6562L-74.5323 41.9488L-121.607 24.5266L-122.642 27.2153Z",
    fill: "url(#paint46_linear_78_5692)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-117.939 -167.78L-45.8112 -140.476L-1.89237 -158.869L156.788 -98.7999L159.528 -104.261L-1.55613 -165.24L-45.0224 -147.037L-112.942 -172.748L-131.033 -223.641L-194.894 -248.177L-197.939 -242.109L-136.178 -219.09L-117.939 -167.78Z",
    fill: "url(#paint47_linear_78_5692)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-13.864 -66.4463L102.348 -22.5094L103.889 -25.5766L-11.106 -69.0535L-28.9691 -119.24L-154.766 -166.436L-165.866 -199.102L-214.542 -217.505L-216.083 -214.437L-168.624 -196.495L-157.216 -164.442L-31.727 -116.633L-13.864 -66.4463Z",
    fill: "url(#paint48_linear_78_5692)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-118.116 -31.7167L-67.2808 -12.8348L95.8281 -81.137L166.005 -54.5738L191.606 17.4357L362.098 82.3304L376.304 122.289L417.238 138.144L420.277 132.09L381.29 117.332L367.084 77.3733L196.739 12.8949L170.991 -59.5309L96.1637 -87.4943L-66.9455 -19.1919L-112.679 -36.8629L-124.073 -68.9134L-250.484 -116.402L-253.218 -110.953L-129.659 -64.1834L-118.116 -31.7167Z",
    fill: "url(#paint49_linear_78_5692)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-49.02 -24.3608L137.149 46.055L265.701 -7.7365L364.753 29.7283L367.923 24.1235L266.484 -14.244L137.483 39.7355L-43.9128 -28.8748L-63.1897 -84.5085L-233.248 -148.831L-236.27 -142.812L-68.5992 -79.3928L-49.02 -24.3608Z",
    fill: "url(#paint50_linear_78_5692)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M338.232 166.428L402.815 190.838L404.358 187.767L340.994 163.818L319.95 104.712L196.727 57.7738L195.184 60.8443L317.038 106.9L338.232 166.428Z",
    fill: "url(#paint51_linear_78_5692)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-274.514 47.7605L-58.5899 129.362L33.7145 90.7706L143.759 132.358L208.73 105.194L252.748 121.829L253.806 119.019L209.047 101.747L144.075 128.911L33.5834 87.511L-58.273 125.915L-271.818 45.2127L-290.895 -8.36481L-304.576 -13.5352L-306.083 -10.5378L-293.592 -5.81706L-274.514 47.7605Z",
    fill: "url(#paint52_linear_78_5692)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-270.082 146.542L-88.3925 215.163L-59.7672 203.202L38.7965 240.428L232.912 159.322L406.289 224.802L419.18 260.982L422.311 259.674L409.127 222.672L232.781 156.07L39.113 236.989L-59.898 199.951L-88.076 211.724L-267.391 144.001L-274.276 124.678L-345.526 97.7681L-346.583 100.571L-277.113 126.808L-270.082 146.542Z",
    fill: "url(#paint53_linear_78_5692)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.88 143.981L263.294 202.299L264.841 199.223L112.798 141.789L85.0794 63.9798L-115.812 -11.9067L-147.297 -100.288L-245.605 -137.424L-247.152 -134.349L-150.065 -97.674L-118.58 -9.2924L82.3115 66.594L109.88 143.981Z",
    fill: "url(#paint54_linear_78_5692)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M396.709 194.8C395.189 197.828 396.521 201.576 399.522 202.712C402.522 203.848 406.591 202.144 408.11 199.115C409.63 196.087 408.298 192.339 405.298 191.203C402.297 190.067 398.229 191.771 396.709 194.8Z",
    fill: "url(#paint55_linear_78_5692)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M190.232 48.9453C188.712 51.974 190.045 55.7219 193.045 56.8577C196.045 57.9934 200.114 56.2897 201.634 53.261C203.154 50.2323 201.821 46.4843 198.821 45.3486C195.821 44.2128 191.752 45.9165 190.232 48.9453Z",
    fill: "url(#paint56_linear_78_5692)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M246.828 139.048C245.308 142.077 246.641 145.825 249.641 146.961C252.641 148.096 256.71 146.393 258.23 143.364C259.75 140.335 258.417 136.587 255.417 135.452C252.416 134.316 248.348 136.019 246.828 139.048Z",
    fill: "url(#paint57_linear_78_5692)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M221.867 168.894C220.347 171.922 221.679 175.67 224.68 176.806C227.68 177.942 231.749 176.238 233.269 173.209C234.789 170.181 233.456 166.433 230.456 165.297C227.455 164.161 223.387 165.865 221.867 168.894Z",
    fill: "url(#paint58_linear_78_5692)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.87524 5.13874C-5.39519 8.16746 -4.06275 11.9155 -1.06233 13.0513C1.93808 14.187 6.00652 12.4833 7.52647 9.45457C9.04641 6.42584 7.71398 2.6778 4.71356 1.54205C1.71314 0.4063 -2.3553 2.11002 -3.87524 5.13874Z",
    fill: "url(#paint59_linear_78_5692)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8691 92.2648C27.3491 95.2935 28.6816 99.0415 31.682 100.177C34.6824 101.313 38.7507 99.6094 40.2706 96.5807C41.7906 93.5519 40.4581 89.8039 37.4577 88.6681C34.4573 87.5324 30.389 89.236 28.8691 92.2648Z",
    fill: "url(#paint60_linear_78_5692)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M415.963 289.138C414.443 292.167 415.775 295.915 418.776 297.051C421.776 298.186 425.844 296.483 427.364 293.454C428.884 290.425 427.552 286.677 424.551 285.542C421.551 284.406 417.483 286.109 415.963 289.138Z",
    fill: "url(#paint61_linear_78_5692)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M257.451 217.471C255.931 220.499 257.264 224.247 260.264 225.383C263.264 226.519 267.333 224.815 268.853 221.786C270.373 218.758 269.04 215.01 266.04 213.874C263.039 212.738 258.971 214.442 257.451 217.471Z",
    fill: "url(#paint62_linear_78_5692)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9863 68.7008C75.4663 71.7295 76.7987 75.4776 79.7992 76.6133C82.7996 77.7491 86.8678 76.0454 88.3878 73.0167C89.9077 69.988 88.5753 66.2399 85.5749 65.1042C82.5745 63.9684 78.9582 65.4828 76.9863 68.7008Z",
    fill: "url(#paint63_linear_78_5692)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M438.197 38.1289C436.677 41.1577 438.01 44.9056 441.01 46.0414C444.01 47.1771 448.079 45.4734 449.599 42.4447C451.119 39.416 449.786 35.668 446.786 34.5323C443.785 33.3965 439.717 35.1002 438.197 38.1289Z",
    fill: "url(#paint64_linear_78_5692)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M357.838 47.4563C355.709 51.6982 357.486 56.6975 361.836 58.7048C366.039 60.2955 371.613 58.4396 374.046 53.5917C376.479 48.7438 374.249 43.9339 370.047 42.3432C365.245 40.5253 360.419 43.025 357.838 47.4563Z",
    fill: "url(#paint65_linear_78_5692)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M411.297 160.025C409.169 164.265 410.945 169.262 415.294 171.269C419.495 172.859 424.919 170.587 427.499 166.158C429.479 161.501 427.85 156.92 423.502 154.914C419.301 153.324 413.877 155.595 411.297 160.025Z",
    fill: "url(#paint66_linear_78_5692)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M246.757 155.551C239.556 152.645 236.308 143.742 239.798 136.473C243.287 129.204 252.196 125.569 259.842 128.293C267.043 131.199 270.291 140.102 266.801 147.371C263.312 154.64 254.404 158.276 246.757 155.551ZM258.679 130.716C252.678 128.294 245.106 131.384 242.198 137.442C239.29 143.499 241.919 150.707 247.92 153.128C253.921 155.55 261.493 152.46 264.401 146.402C267.309 140.345 264.68 133.138 258.679 130.716Z",
    fill: "url(#paint67_linear_78_5692)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M416.667 303.824C409.466 300.918 406.373 292.439 409.708 284.746C413.197 277.477 422.106 273.841 429.752 276.565C436.953 279.472 440.201 288.375 436.712 295.644C433.222 302.913 423.868 306.73 416.667 303.824ZM428.589 278.988C422.588 276.567 415.016 279.657 412.108 285.714C409.2 291.772 411.83 298.979 417.83 301.401C423.831 303.823 431.403 300.732 434.311 294.675C437.219 288.618 434.59 281.41 428.589 278.988Z",
    fill: "url(#paint68_linear_78_5692)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M257.81 233.809C250.609 230.903 247.361 221.999 250.85 214.73C254.34 207.462 263.248 203.826 270.895 206.55C278.096 209.456 281.343 218.359 277.854 225.628C274.365 232.897 265.011 236.715 257.81 233.809ZM269.732 208.973C263.731 206.551 256.158 209.642 253.251 215.699C250.343 221.757 252.972 228.964 258.973 231.386C264.974 233.807 272.546 230.717 275.454 224.66C278.362 218.602 275.732 211.395 269.732 208.973Z",
    fill: "url(#paint69_linear_78_5692)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M396.325 208.934C390.17 206.089 387.095 199.063 390.448 192.824C393.356 186.766 401.219 183.07 407.375 185.916C413.53 188.762 416.605 195.787 413.252 202.027C410.053 208.69 402.326 211.356 396.325 208.934ZM406.503 187.733C401.102 185.554 394.866 188.099 392.694 193.369C390.077 198.82 392.242 204.756 397.488 206.511C402.889 208.691 409.125 206.146 411.297 200.876C413.914 195.424 411.749 189.489 406.348 187.309L406.503 187.733Z",
    fill: "url(#paint70_linear_78_5692)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M439.102 51.768C432.946 48.9223 430.317 41.715 433.225 35.6576C436.578 29.4183 444.15 26.328 450.151 28.7497C456.307 31.5955 458.936 38.8028 456.028 44.8602C452.675 51.0994 445.103 54.1898 439.102 51.768ZM449.279 30.5669C443.878 28.3874 437.642 30.9323 435.025 36.384C432.408 41.8357 434.573 47.7711 439.974 49.9507C445.375 52.1303 451.611 49.5854 454.228 44.1337C456.845 38.682 454.68 32.7465 449.279 30.5669Z",
    fill: "url(#paint71_linear_78_5692)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M316.354 -5.30651C309.909 -7.54607 307.126 -15.176 310.478 -21.414C313.386 -27.4703 321.402 -30.7418 327.402 -28.3205C333.556 -25.4753 336.185 -18.2693 333.277 -12.213C329.925 -5.97493 322.509 -2.46132 316.354 -5.30651ZM326.53 -26.5036C321.13 -28.6827 314.895 -26.1382 312.278 -20.6876C309.662 -15.2369 311.827 -9.30258 317.226 -7.12341C322.626 -4.94423 328.861 -7.48874 331.032 -12.7577C333.649 -18.2083 331.484 -24.1426 326.239 -25.8979L326.53 -26.5036Z",
    fill: "url(#paint72_linear_78_5692)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M357.524 68.8293C347.322 64.7123 343.147 53.2655 348.244 43.3918C353.188 33.0941 365.214 28.1859 374.97 32.4847C385.172 36.6017 389.347 48.0486 384.25 57.9223C379.306 68.2199 367.28 73.1281 357.524 68.8293ZM373.516 35.5134C365.115 32.1229 355.316 36.1222 351.245 44.6026C347.174 53.083 350.577 62.4101 358.978 65.8006C367.379 69.1911 377.178 65.1919 381.249 56.7114C385.32 48.231 381.918 38.9039 373.516 35.5134Z",
    fill: "url(#paint73_linear_78_5692)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M409.686 181.897C399.485 177.78 395.309 166.333 400.407 156.459C405.35 146.161 417.376 141.253 427.132 145.552C437.334 149.669 441.51 161.116 436.412 170.99C431.469 181.287 419.442 186.196 409.686 181.897ZM425.679 148.581C417.277 145.19 407.478 149.19 403.407 157.67C399.336 166.15 402.739 175.478 411.14 178.868C419.541 182.258 429.34 178.259 433.411 169.779C437.482 161.298 434.08 151.971 425.679 148.581Z",
    fill: "url(#paint74_linear_78_5692)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.3764 1432.78L147.225 1404.81L149.424 1408.78L84.2608 1436.05L60.9403 1516.45L-61.5225 1567.7L-72.235 1600.86L-178.531 1645.7L-276.197 1608.59L-274.959 1604.58L-178.921 1640.62L-76.1196 1597.59L-65.845 1564.27L56.6178 1513.02L80.3764 1432.78Z",
    fill: "url(#paint75_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-322.966 1484.15L-211.756 1437.67L-89.9384 1483.89L-10.8568 1450.49L21.8595 1344.51L278.631 1237.54L372.271 1273.07L456.913 1237.34L459.523 1241.44L372.779 1277.69L279.14 1242.16L26.0153 1348.31L-6.70095 1454.28L-89.5521 1488.91L-211.37 1442.69L-320.356 1488.24L-322.966 1484.15Z",
    fill: "url(#paint76_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.234 1172.46L415.284 1098.4L463.794 1116.82L592.073 1063.52L594.288 1067.52L464.187 1121.94L415.676 1103.52L242.02 1176.15L195.152 1328.08L32.8091 1395.98L0.150821 1501.85L-196.697 1584.19L-248.295 1564.59L-280.661 1578.48L-283.192 1573.91L-248.687 1559.48L-197.09 1579.07L-4.20148 1498.39L28.4568 1392.53L191.241 1324.79L238.234 1172.46Z",
    fill: "url(#paint77_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-240.949 1077.86L-171.669 1049.66L-61.1122 1090.51L29.2758 1053.73L341.536 1169.09L415.146 1139.14L417.145 1143.24L341.912 1173.85L29.7708 1058.11L-60.195 1095.05L-171.174 1054.05L-238.408 1081.74L-240.949 1077.86Z",
    fill: "url(#paint78_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-223.149 1364.98L-118.857 1321.33L-53.2849 1346.24L175.921 1250.67L180.311 1258.6L-51.9452 1356.15L-117.517 1331.24L-215.081 1372.07L-238.557 1448.21L-331.197 1487.33L-335.901 1478.83L-246.749 1441.52L-223.149 1364.98Z",
    fill: "url(#paint79_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.2566 1211.76L91.7823 1141.88L94.0064 1145.89L-72.4533 1215.46L-94.9209 1289.84L-276.72 1365.82L-291.618 1414.07L-362.065 1443.51L-364.164 1439.09L-295.989 1410.6L-281.091 1362.35L-99.2922 1286.37L-76.2566 1211.76Z",
    fill: "url(#paint80_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-230.675 1164.31L-157.513 1134.05L86.7318 1226.83L187.989 1184.46L221.151 1076.92L467.3 973.922L485.668 914.357L544.968 889.544L549.225 897.86L493.841 921.034L474.914 980.834L228.764 1083.83L195.726 1190.97L87.6323 1236.55L-156.053 1143.53L-222.626 1171.39L-237.419 1219.36L-419.234 1295.44L-424.05 1287.36L-245.469 1212.29L-230.675 1164.31Z",
    fill: "url(#paint81_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-129.913 1150.53L138.808 1038.19L330.963 1111.12L473.947 1051.34L478.614 1059.77L332.292 1120.94L139.826 1047.46L-121.785 1157.16L-147.164 1239.38L-392.641 1342.35L-397.308 1333.92L-155.292 1232.75L-129.913 1150.53Z",
    fill: "url(#paint82_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.563 849.197L521.303 810.451L523.974 814.639L432.941 852.672L405.483 941.574L226.831 1016.21L224.286 1011.62L401.231 937.693L428.563 849.197Z",
    fill: "url(#paint83_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-464.819 1055.99L-153.636 925.698L-15.7358 977.974L143.399 911.522L240.664 948.394L303.874 921.999L306.355 926.473L241.481 953.563L143.784 916.527L-15.2284 982.584L-152.696 930.471L-460.984 1059.21L-485.544 1138.69L-505.505 1147.02L-507.676 1143.11L-489.378 1135.47L-464.819 1055.99Z",
    fill: "url(#paint84_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-463.282 910.301L-201.385 800.678L-159.1 816.696L-16.4351 757.511L273.087 867.18L523.793 762.571L540.258 709.332L545.004 711.129L528.052 765.946L274.025 871.941L-15.9289 762.109L-158.162 821.457L-200.447 805.439L-459.455 913.513L-468.48 942.696L-570.865 985.417L-573.463 981.349L-472.184 939.089L-463.282 910.301Z",
    fill: "url(#paint85_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.44 895.423L315.301 802.791L317.534 806.817L97.3838 898.735L62.1349 1014.4L-228.738 1135.84L-269.459 1267.61L-411.917 1326.73L-414.15 1322.71L-273.847 1264.13L-233.126 1132.36L57.7463 1010.92L93.44 895.423Z",
    fill: "url(#paint86_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.625 1208.28C447.121 1203.75 448.724 1198.55 453.202 1196.68C457.679 1194.8 463.352 1196.96 465.857 1201.48C468.361 1206.01 466.757 1211.21 462.28 1213.08C457.802 1214.96 452.129 1212.8 449.625 1208.28Z",
    fill: "url(#paint87_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.685 1122.14C403.181 1117.62 404.785 1112.42 409.262 1110.54C413.74 1108.67 419.413 1110.82 421.917 1115.35C424.421 1119.88 422.818 1125.08 418.34 1126.95C413.863 1128.82 408.19 1126.67 405.249 1121.98L405.685 1122.14Z",
    fill: "url(#paint88_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.078 804.007C510.572 799.477 512.177 794.271 516.659 792.396C521.141 790.52 526.819 792.677 529.326 797.208C531.833 801.739 530.228 806.944 525.622 809.22C521.14 811.096 515.462 808.939 512.955 804.408L513.078 804.007Z",
    fill: "url(#paint89_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.108 1030.33C214.601 1025.8 216.206 1020.59 220.688 1018.72C225.17 1016.84 230.849 1019 233.355 1023.53C235.862 1028.06 234.257 1033.27 229.651 1035.54C225.169 1037.42 219.491 1035.26 216.984 1030.73L217.108 1030.33Z",
    fill: "url(#paint90_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.846 894.001C293.341 889.475 294.945 884.275 299.423 882.402C303.9 880.528 309.573 882.683 312.077 887.209C314.582 891.735 312.978 896.935 308.5 898.809C304.023 900.682 298.35 898.527 295.846 894.001Z",
    fill: "url(#paint91_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.121 851.882C254.615 847.351 256.22 842.146 260.702 840.27C265.184 838.394 270.862 840.552 273.369 845.083C275.876 849.613 274.271 854.819 269.665 857.095C265.183 858.97 259.505 856.813 256.998 852.282L257.121 851.882Z",
    fill: "url(#paint92_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.171 1222.39C271.667 1217.86 273.271 1212.66 277.872 1210.39C282.349 1208.52 288.022 1210.67 290.526 1215.2C293.031 1219.72 291.427 1224.92 286.95 1226.8C282.472 1228.67 276.799 1226.52 274.295 1221.99L274.171 1222.39Z",
    fill: "url(#paint93_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6385 1129.32C82.1342 1124.79 83.7377 1119.59 88.2154 1117.72C92.6931 1115.84 98.366 1118 100.87 1122.52C103.374 1127.05 101.771 1132.25 97.2933 1134.12C92.8156 1136 87.1428 1133.84 84.6385 1129.32Z",
    fill: "url(#paint94_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.239 663.884C533.737 659.362 535.339 654.168 539.812 652.296C544.286 650.424 549.953 652.577 552.891 657.264C555.393 661.785 553.791 666.98 549.318 668.852C544.844 670.723 539.177 668.571 536.675 664.049L536.239 663.884Z",
    fill: "url(#paint95_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.342 778.395C304.838 773.869 306.441 768.669 310.919 766.796C315.396 764.922 321.069 767.077 323.573 771.603C326.078 776.129 324.474 781.329 319.996 783.203C315.519 785.076 309.846 782.921 307.342 778.395Z",
    fill: "url(#paint96_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7564 1007.36C47.2546 1002.84 48.8565 997.647 53.3299 995.775C57.8033 993.903 63.4708 996.056 66.4086 1000.74C68.9105 1005.26 67.3086 1010.46 62.8352 1012.33C58.3618 1014.2 52.6943 1012.05 50.1925 1007.53L49.7564 1007.36Z",
    fill: "url(#paint97_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.847 1031.74C580.343 1027.21 581.947 1022.01 586.424 1020.14C590.902 1018.26 596.575 1020.42 599.079 1024.95C601.583 1029.47 599.98 1034.67 595.502 1036.55C591.025 1038.42 585.352 1036.26 582.847 1031.74Z",
    fill: "url(#paint98_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.229 1022.73C460.474 1015.94 462.693 1008.74 469.408 1005.93C476.123 1003.12 483.976 1006.11 487.731 1012.89C491.487 1019.68 489.267 1026.88 482.552 1029.69C475.838 1032.5 468.108 1029.12 464.229 1022.73Z",
    fill: "url(#paint99_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.384 1237.18C161.937 1230.95 164.283 1223.34 170.57 1220.36C176.856 1217.38 185.156 1220.54 188.916 1227.33C192.363 1233.56 190.017 1241.17 183.73 1244.15C177.444 1247.13 169.144 1243.98 165.821 1237.35L165.384 1237.18Z",
    fill: "url(#paint100_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.405 854.327C532.645 847.529 535.304 840.486 541.592 837.506C547.88 834.526 556.181 837.679 559.505 844.311C562.952 850.543 560.606 858.152 554.318 861.132C548.154 863.712 539.729 860.959 535.969 854.161L536.405 854.327Z",
    fill: "url(#paint101_linear_78_5692)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.9113 1343.42L136.349 1322.73L137.796 1325.97L89.4821 1346.19L72.1594 1405.55L-18.2894 1443.4L-25.9649 1468.29L-104.616 1501.21L-176.886 1473.75L-175.895 1470.54L-105.378 1497.33L-28.9738 1465.36L-21.422 1440.86L69.1508 1402.61L86.9113 1343.42Z",
    fill: "url(#paint102_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-211.59 1381.54L-129.294 1347.14L-39.5567 1381.19L19.262 1356.95L43.5236 1278.37L233.136 1199.11L302.499 1225.43L365.332 1199.17L366.887 1201.98L302.819 1229.1L233.89 1202.95L46.624 1280.87L22.3625 1359.46L-38.8029 1385.03L-128.974 1350.81L-209.601 1384.51L-211.59 1381.54Z",
    fill: "url(#paint103_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.301 1151.15L334.538 1096.25L370.261 1109.82L465.17 1070.47L466.752 1073.33L370.587 1113.55L334.864 1099.99L206.455 1153.7L171.676 1266.43L51.3116 1316.43L27.1286 1394.82L-118.251 1455.63L-156.179 1441.23L-180.503 1451.4L-181.96 1448.14L-156.504 1437.49L-118.576 1451.89L24.54 1392.03L48.1574 1313.88L168.647 1263.48L203.301 1151.15Z",
    fill: "url(#paint104_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-150.832 1080.86L-99.5329 1060.31L-17.6696 1090.55L48.9037 1063.46L279.724 1148.74L334.39 1126.49L335.784 1129.53L280.155 1151.84L49.3347 1066.56L-17.3579 1094.03L-99.2211 1063.78L-149.016 1084.05L-150.832 1080.86Z",
    fill: "url(#paint105_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.781 1293.42L-60.5287 1261.44L-12.0063 1279.87L157.447 1208.61L160.897 1214.84L-11.2367 1286.88L-59.7591 1268.44L-131.652 1298.88L-148.95 1354.98L-217.915 1383.84L-221.365 1377.61L-155.202 1349.92L-137.781 1293.42Z",
    fill: "url(#paint106_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.2443 1180.39L95.1721 1128.39L96.7608 1131.26L-26.0766 1182.95L-43.1026 1238.1L-177.62 1293.97L-188.637 1329.65L-240.46 1351.66L-242.367 1348.22L-191.362 1327.26L-180.345 1291.57L-46.2703 1235.54L-29.2443 1180.39Z",
    fill: "url(#paint107_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-143.417 1144.97L-89.2768 1122.67L91.2861 1191.26L166.248 1159.89L190.78 1080.34L372.591 1004.26L386.274 959.889L430.345 941.796L433.787 948.016L392.39 965.338L378.829 1009.31L196.459 1085.62L172.051 1164.77L92.0539 1198.25L-88.0729 1129.82L-137.302 1150.42L-148.15 1185.6L-282.97 1242.02L-286.411 1235.8L-154.389 1180.55L-143.417 1144.97Z",
    fill: "url(#paint108_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.635 1134.58L129.982 1051.55L272.253 1105.55L377.959 1061.36L381.382 1067.54L272.893 1112.89L130.623 1058.9L-62.9868 1139.83L-81.7446 1200.6L-263.115 1276.42L-266.538 1270.24L-87.5153 1195.75L-68.635 1134.58Z",
    fill: "url(#paint109_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.132 911.815L412.841 883.461L414.875 886.5L347.179 914.784L326.996 980.135L195.015 1035.28L192.981 1032.24L323.823 977.571L344.132 911.815Z",
    fill: "url(#paint110_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-316.588 1064.83L-86.4838 968.739L15.6572 1007.02L133.204 957.932L205.396 985.299L251.971 965.85L253.831 969.206L205.715 988.954L133.524 961.587L15.9765 1010.67L-85.6099 972.163L-313.496 1067.32L-331.702 1126.24L-346.55 1132.1L-348.1 1129.3L-334.793 1123.74L-316.588 1064.83Z",
    fill: "url(#paint111_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-315.354 957.02L-121.648 876.194L-90.5813 887.962L15.1268 843.855L229.575 925.087L414.858 848.119L427.054 808.681L430.074 809.826L417.512 850.446L229.894 928.732L15.4456 847.5L-89.831 891.771L-121.208 879.445L-312.7 959.348L-319.408 981.039L-395.23 1012.68L-396.655 1009.49L-322.062 978.711L-315.354 957.02Z",
    fill: "url(#paint112_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2937 946.045L260.421 877.872L262.016 880.748L99.4739 948.614L72.9557 1034.42L-142.056 1124.19L-172.094 1221.39L-277.033 1265.2L-279.073 1262.16L-175.274 1218.82L-145.237 1121.62L69.9011 1031.44L96.2937 946.045Z",
    fill: "url(#paint113_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.955 1177.39C358.076 1173.99 359.31 1169.99 362.668 1168.59C366.026 1167.18 370.39 1168.84 372.268 1172.24C374.147 1175.63 372.913 1179.63 369.555 1181.03C366.197 1182.44 361.833 1180.78 359.955 1177.39Z",
    fill: "url(#paint114_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.154 1114.03C325.276 1110.63 326.509 1106.63 329.867 1105.23C333.226 1103.82 337.589 1105.48 339.468 1108.87C341.346 1112.27 340.112 1116.27 336.754 1117.67C333.396 1119.08 329.032 1117.42 327.154 1114.03Z",
    fill: "url(#paint115_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.693 878.385C404.815 874.99 406.048 870.99 409.407 869.585C412.765 868.18 417.128 869.837 419.007 873.232C420.885 876.627 419.652 880.626 416.293 882.032C412.935 883.437 408.571 881.779 406.693 878.385Z",
    fill: "url(#paint116_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.877 1045.65C185.998 1042.25 187.232 1038.25 190.59 1036.85C193.948 1035.44 198.312 1037.1 200.19 1040.5C202.068 1043.89 200.835 1047.89 197.477 1049.3C194.118 1050.7 189.755 1049.04 187.877 1045.65Z",
    fill: "url(#paint117_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.877 945.43C243.999 942.036 245.232 938.036 248.59 936.631C251.948 935.225 256.312 936.883 258.19 940.277C260.068 943.672 258.835 947.672 255.477 949.077C252.119 950.482 247.755 948.825 245.877 945.43Z",
    fill: "url(#paint118_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.402 913.9C215.524 910.505 216.757 906.505 220.115 905.1C223.474 903.694 227.837 905.352 229.716 908.747C231.594 912.141 230.36 916.141 227.002 917.547C223.644 918.952 219.28 917.294 217.402 913.9Z",
    fill: "url(#paint119_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.046 1188.1C228.168 1184.7 229.402 1180.7 232.76 1179.3C236.118 1177.89 240.482 1179.55 242.36 1182.94C244.238 1186.34 243.005 1190.34 239.647 1191.74C236.288 1193.15 231.925 1191.49 230.483 1188.26L230.046 1188.1Z",
    fill: "url(#paint120_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0855 1119.01C88.2073 1115.62 89.4407 1111.62 92.799 1110.21C96.1573 1108.81 100.521 1110.47 102.399 1113.86C104.277 1117.26 103.044 1121.26 99.6858 1122.66C96.3275 1124.07 91.9637 1122.41 90.0855 1119.01Z",
    fill: "url(#paint121_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6657 1005.6C8.78754 1002.2 10.021 998.205 13.3792 996.799C16.7375 995.394 21.1011 997.052 22.9793 1000.45C24.8575 1003.84 23.6241 1007.84 20.2658 1009.25C16.9075 1010.65 12.5439 1008.99 10.6657 1005.6Z",
    fill: "url(#paint122_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.673 775.084C421.795 771.69 423.029 767.69 426.387 766.285C429.745 764.879 434.109 766.537 435.987 769.932C437.865 773.326 436.632 777.326 433.274 778.731C429.915 780.137 425.552 778.479 423.673 775.084Z",
    fill: "url(#paint123_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.517 859.681C252.639 856.286 253.872 852.287 257.231 850.881C260.589 849.476 264.953 851.134 266.831 854.528C268.709 857.923 267.476 861.923 264.117 863.328C260.759 864.733 256.395 863.076 254.517 859.681Z",
    fill: "url(#paint124_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1109 1029.05C62.2327 1025.65 63.4661 1021.65 66.8244 1020.25C70.1827 1018.84 74.5465 1020.5 76.4247 1023.89C78.3028 1027.29 77.0695 1031.29 73.7112 1032.69C70.3529 1034.1 65.9891 1032.44 64.1109 1029.05Z",
    fill: "url(#paint125_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.71 1265.68C160.832 1262.29 162.066 1258.29 165.424 1256.88C168.782 1255.48 173.146 1257.14 175.024 1260.53C176.902 1263.93 175.669 1267.93 172.311 1269.33C168.952 1270.74 164.589 1269.08 162.71 1265.68Z",
    fill: "url(#paint126_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3025 1284.17C38.4243 1280.78 39.6577 1276.78 43.016 1275.37C46.3742 1273.97 50.7379 1275.62 52.6161 1279.02C54.4942 1282.41 53.2608 1286.41 49.9025 1287.82C46.5443 1289.22 42.1806 1287.56 40.7388 1284.34L40.3025 1284.17Z",
    fill: "url(#paint127_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.42 1046.86C456.541 1043.47 457.775 1039.47 461.133 1038.06C464.491 1036.66 468.855 1038.31 470.733 1041.71C472.611 1045.1 471.378 1049.1 468.02 1050.51C464.662 1051.91 460.298 1050.25 458.42 1046.86Z",
    fill: "url(#paint128_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.415 1040.34C367.6 1035.26 369.202 1030.06 374.236 1027.95C379.147 1026.25 384.816 1028.4 387.754 1033.09C390.57 1038.18 388.968 1043.37 383.934 1045.48C379.336 1047.75 373.231 1045.43 370.415 1040.34Z",
    fill: "url(#paint129_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.544 1198.83C146.604 1194.14 148.33 1188.55 153.366 1186.44C157.842 1184.57 164.509 1186.65 166.889 1191.58C169.392 1196.1 167.666 1201.7 163.067 1203.97C158.154 1205.68 152.483 1203.52 149.544 1198.83Z",
    fill: "url(#paint130_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21.052 1284.84C-23.4353 1279.91 -21.8302 1274.71 -17.2244 1272.43C-12.6187 1270.15 -6.50325 1272.48 -3.68306 1277.57C-1.17622 1282.11 -2.46796 1287.88 -7.51057 1289.99C-12.1164 1292.26 -18.2318 1289.94 -21.052 1284.84Z",
    fill: "url(#paint131_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.225 915.925C421.72 911.397 423.448 905.795 428.05 903.52C432.653 901.246 438.641 903.968 441.583 908.661C444.401 913.755 442.797 918.957 437.758 921.065C433.155 923.34 427.044 921.018 424.225 915.925Z",
    fill: "url(#paint132_linear_78_5692)"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6939 1311.47L131.951 1293.37L133.522 1296.21L91.3883 1313.84L76.4185 1365.57L-2.79211 1398.72L-9.35325 1420L-78.014 1449.09L-141.083 1425.12L-140.217 1422.31L-78.4613 1445.78L-12.1716 1418.03L-5.48659 1396.35L73.724 1363.2L88.6939 1311.47Z",
    fill: "url(#paint133_linear_78_5692)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M-171.377 1344.37L-99.7673 1314.79L-21.2993 1344.56L29.9807 1322.78L51.0568 1254.51L216.763 1185.25L277.456 1208.28L332.073 1185.11L333.628 1187.92L277.899 1211.55L217.206 1188.52L53.7239 1256.86L32.6478 1325.13L-20.734 1347.44L-99.202 1317.66L-169.822 1347.18L-171.377 1344.37Z",
    fill: "url(#paint134_linear_78_5692)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M190.984 1143.43L305.245 1095.64L336.556 1107.52L419.141 1072.98L420.847 1075.43L337.006 1110.86L305.695 1098.97L193.256 1145.65L162.966 1243.83L58.1968 1288.01L37.2559 1355.89L-90.015 1409.12L-123.09 1396.56L-144.019 1405.32L-145.725 1402.86L-123.54 1393.23L-90.4654 1405.79L34.4182 1353.91L55.4838 1285.62L160.694 1241.61L190.984 1143.43Z",
    fill: "url(#paint135_linear_78_5692)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M-118.189 1082.1L-73.8086 1064.04L-2.49743 1090.38L55.9548 1066.59L257.651 1141.11L305.16 1122.1L306.371 1124.23L258.082 1144.21L56.3859 1069.7L-2.06647 1093.48L-73.3775 1067.14L-117.098 1084.6L-118.189 1082.1Z",
    fill: "url(#paint136_linear_78_5692)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.94 1267.75L-39.657 1239.6L2.74485 1255.71L150.767 1193.76L153.589 1198.86L3.32442 1261.75L-38.7641 1246.2L-101.998 1272.32L-117.196 1321.61L-176.629 1346.48L-179.888 1341.21L-122.137 1317.04L-106.94 1267.75Z",
    fill: "url(#paint137_linear_78_5692)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M-12.3139 1168.89L96.1918 1123.54L97.7803 1126.41L-9.46393 1170.88L-24.3612 1219.13L-141.956 1268.28L-151.028 1299.26L-196.475 1318.25L-198.189 1315.79L-153.878 1297.27L-144.238 1266.05L-27.086 1216.73L-12.3139 1168.89Z",
    fill: "url(#paint138_linear_78_5692)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M-111.762 1138.01L-64.3332 1118.51L93.1188 1178.32L158.573 1150.93L179.9 1081.77L338.779 1015.29L350.738 976.514L388.779 960.596L392.031 965.851L355.668 981.067L343.71 1019.84L184.954 1085.93L163.503 1155.49L93.5738 1184.75L-63.8783 1124.94L-106.395 1142.73L-115.888 1173.51L-233.929 1222.9L-236.621 1217.41L-121.378 1169.19L-111.762 1138.01Z",
    fill: "url(#paint139_linear_78_5692)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M-46.8194 1129L126.754 1056.44L250.801 1103.52L343.028 1065.31L346.262 1070.53L251.687 1110.07L127.206 1062.83L-41.9164 1133.52L-57.7877 1186.51L-216.34 1252.79L-219.574 1247.57L-63.2469 1182.22L-46.8194 1129Z",
    fill: "url(#paint140_linear_78_5692)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M313.653 934.521L373.839 909.729L375.43 912.6L316.382 936.916L298.703 994.156L183.644 1042.58L182.053 1039.71L295.974 991.761L313.653 934.521Z",
    fill: "url(#paint141_linear_78_5692)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M-263.13 1067.95L-61.9756 984.293L27.0769 1018.05L129.778 974.821L192.461 998.583L233.37 981.845L234.489 984.477L192.903 1001.84L130.22 978.081L27.2084 1020.75L-61.4119 987.157L-260.471 1070.28L-276.355 1121.69L-289.108 1127.01L-290.659 1124.22L-279.015 1119.35L-263.13 1067.95Z",
    fill: "url(#paint142_linear_78_5692)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M-262.438 974.022L-93.083 903.357L-65.4677 913.817L26.5268 875.088L213.671 946.418L375.4 878.591L386.011 844.28L389.031 845.424L378.055 880.919L213.802 949.111L26.9677 878.339L-65.3365 916.511L-92.5202 906.213L-259.662 975.955L-265.516 994.886L-331.93 1022.6L-333.046 1019.97L-268.17 992.558L-262.438 974.022Z",
    fill: "url(#paint143_linear_78_5692)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3506 964.414L240.501 904.645L242.096 907.521L100.086 966.814L77.0869 1041.23L-110.675 1119.98L-136.941 1204.98L-228.638 1242.91L-230.358 1240.44L-139.677 1202.58L-113.41 1117.58L74.2258 1039.24L97.3506 964.414Z",
    fill: "url(#paint144_linear_78_5692)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M127.423 1285.03C125.858 1282.2 126.968 1278.6 129.766 1277.43C132.565 1276.26 136.492 1277.75 138.057 1280.58C139.622 1283.41 138.512 1287.01 135.714 1288.18C132.915 1289.35 128.988 1287.86 127.423 1285.03Z",
    fill: "url(#paint145_linear_78_5692)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M327.257 1166.31C325.692 1163.48 326.802 1159.88 329.6 1158.71C332.399 1157.54 336.326 1159.03 337.891 1161.86C339.456 1164.69 338.346 1168.29 335.548 1169.46C332.749 1170.63 328.822 1169.14 327.257 1166.31Z",
    fill: "url(#paint146_linear_78_5692)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M299.036 1111.15C297.471 1108.32 298.581 1104.72 301.379 1103.55C304.178 1102.38 308.105 1103.87 309.671 1106.7C311.236 1109.53 310.126 1113.13 307.327 1114.3C304.529 1115.47 300.601 1113.98 299.036 1111.15Z",
    fill: "url(#paint147_linear_78_5692)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M368.368 905.229C366.803 902.4 367.913 898.8 370.712 897.629C373.51 896.458 377.437 897.95 379.003 900.779C380.568 903.607 379.458 907.207 376.659 908.378C373.861 909.55 369.933 908.058 368.368 905.229Z",
    fill: "url(#paint148_linear_78_5692)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M177.509 1051.67C175.943 1048.84 177.054 1045.24 179.852 1044.07C182.651 1042.9 186.578 1044.39 188.143 1047.22C189.708 1050.05 188.598 1053.65 185.8 1054.82C183.001 1055.99 179.074 1054.5 177.509 1051.67Z",
    fill: "url(#paint149_linear_78_5692)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M228.091 963.628C226.526 960.799 227.636 957.199 230.434 956.028C233.233 954.857 237.16 956.349 238.725 959.178C240.29 962.007 239.18 965.607 236.382 966.778C233.583 967.949 229.656 966.457 228.091 963.628Z",
    fill: "url(#paint150_linear_78_5692)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M203.149 936.622C201.584 933.794 202.694 930.194 205.493 929.022C208.291 927.851 212.219 929.343 213.784 932.172C215.349 935.001 214.239 938.601 211.44 939.772C208.642 940.943 204.714 939.451 203.149 936.622Z",
    fill: "url(#paint151_linear_78_5692)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.05583 1099.92C-6.62099 1097.09 -5.51094 1093.49 -2.71237 1092.32C0.0861911 1091.15 4.01365 1092.64 5.57881 1095.47C7.14397 1098.3 6.03392 1101.9 3.23536 1103.07C0.436791 1104.24 -3.49067 1102.75 -5.05583 1099.92Z",
    fill: "url(#paint152_linear_78_5692)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M214.021 1175.59C212.455 1172.76 213.565 1169.16 216.364 1167.99C219.163 1166.82 223.09 1168.31 224.655 1171.14C226.22 1173.97 225.11 1177.57 222.312 1178.74C219.513 1179.91 215.586 1178.42 214.021 1175.59Z",
    fill: "url(#paint153_linear_78_5692)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8115 1115.41C90.2463 1112.58 91.3564 1108.98 94.155 1107.81C96.9535 1106.64 100.881 1108.13 102.446 1110.96C104.011 1113.79 102.901 1117.39 100.102 1118.56C97.3039 1119.73 93.3766 1118.24 91.8115 1115.41Z",
    fill: "url(#paint154_linear_78_5692)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6962 1016.42C21.1311 1013.59 22.2412 1009.99 25.0397 1008.82C27.8383 1007.65 31.7656 1009.14 33.3308 1011.97C34.8959 1014.8 33.7858 1018.4 30.9873 1019.57C28.1887 1020.74 24.2614 1019.25 22.6962 1016.42Z",
    fill: "url(#paint155_linear_78_5692)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M383.188 814.947C381.623 812.118 382.733 808.518 385.532 807.347C388.33 806.176 392.258 807.668 393.823 810.497C395.388 813.326 394.278 816.926 391.479 818.097C388.681 819.268 384.754 817.776 383.188 814.947Z",
    fill: "url(#paint156_linear_78_5692)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M235.302 888.774C233.737 885.946 234.847 882.346 237.645 881.175C240.444 880.004 244.371 881.496 245.936 884.324C247.501 887.153 246.391 890.753 243.593 891.924C240.794 893.095 236.867 891.603 235.302 888.774Z",
    fill: "url(#paint157_linear_78_5692)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3954 1036.61C67.8303 1033.79 68.9404 1030.19 71.7389 1029.01C74.5375 1027.84 78.4648 1029.34 80.03 1032.16C81.5951 1034.99 80.485 1038.59 77.6865 1039.76C74.8879 1040.94 71.397 1039.61 69.3954 1036.61Z",
    fill: "url(#paint158_linear_78_5692)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M155.589 1243.41C154.024 1240.58 155.134 1236.98 157.932 1235.81C160.731 1234.64 164.658 1236.13 166.223 1238.96C167.789 1241.79 166.678 1245.39 163.88 1246.56C161.081 1247.73 157.154 1246.24 155.589 1243.41Z",
    fill: "url(#paint159_linear_78_5692)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3446 1259.48C46.7794 1256.65 47.8894 1253.05 50.688 1251.88C53.4866 1250.71 57.414 1252.2 58.9792 1255.03C60.5444 1257.86 59.4343 1261.46 56.6357 1262.63C53.8372 1263.8 49.9097 1262.31 48.3446 1259.48Z",
    fill: "url(#paint160_linear_78_5692)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M413.509 1052.49C411.943 1049.66 413.054 1046.06 415.852 1044.89C418.651 1043.72 422.578 1045.21 424.143 1048.04C425.708 1050.86 424.598 1054.46 421.8 1055.64C419.001 1056.81 415.074 1055.31 413.509 1052.49Z",
    fill: "url(#paint161_linear_78_5692)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M336.877 1046.54C334.685 1042.58 336.165 1037.78 340.207 1035.74C344.125 1034.1 349.484 1035.69 351.989 1040.21C354.493 1044.74 352.577 1049.37 348.659 1051.01C344.741 1052.65 339.504 1050.66 336.877 1046.54Z",
    fill: "url(#paint162_linear_78_5692)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M144.074 1185.21C141.446 1181.08 143.363 1176.45 147.404 1174.41C151.759 1172.94 156.682 1174.36 159.186 1178.89C161.378 1182.85 159.897 1187.65 155.856 1189.69C151.938 1191.32 146.702 1189.34 144.074 1185.21Z",
    fill: "url(#paint163_linear_78_5692)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.08093 1260.02C-7.26957 1256.06 -6.22708 1251.11 -1.75467 1249.23C2.59455 1247.76 7.38899 1249.58 10.0135 1253.7C12.5148 1258.22 11.0364 1263.02 6.68722 1264.49C2.338 1265.96 -2.8923 1263.97 -5.08093 1260.02Z",
    fill: "url(#paint164_linear_78_5692)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M383.357 938.129C381.166 934.169 382.646 929.369 386.688 927.33C390.606 925.69 395.842 927.679 398.47 931.806C400.538 936.166 399.181 940.566 395.14 942.605C391.222 944.245 385.985 942.256 383.357 938.129Z",
    fill: "url(#paint165_linear_78_5692)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M145.456 1278.13C149.032 1284.92 146.414 1293.1 139.565 1296.53C132.717 1299.96 123.841 1296.26 120.265 1289.46C116.689 1282.67 119.307 1274.5 126.155 1271.06C132.873 1268.04 141.451 1271.18 145.456 1278.13ZM143.217 1279.13C140.237 1273.48 132.945 1270.81 127.347 1273.33C121.749 1275.85 119.524 1282.8 122.504 1288.46C125.484 1294.12 132.775 1296.78 138.374 1294.26C143.972 1291.74 146.197 1284.79 143.217 1279.13Z",
    fill: "url(#paint166_linear_78_5692)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M345.556 1159.97C349.132 1166.76 346.383 1175.35 339.667 1178.37C332.95 1181.39 323.945 1178.1 320.369 1171.31C316.794 1164.52 319.542 1155.93 326.259 1152.91C332.975 1149.89 341.981 1153.18 345.556 1159.97ZM343.317 1160.98C340.338 1155.32 333.048 1152.65 327.451 1155.17C321.853 1157.69 319.628 1164.64 322.608 1170.3C325.588 1175.96 332.878 1178.63 338.475 1176.11C344.072 1173.59 346.297 1166.64 343.317 1160.98Z",
    fill: "url(#paint167_linear_78_5692)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M246.713 955.023C250.289 961.813 247.54 970.4 240.822 973.424C234.105 976.447 225.527 973.308 221.522 966.361C217.946 959.571 220.564 951.393 227.412 947.96C234.261 944.528 242.708 948.076 246.713 955.023ZM244.474 956.031C241.494 950.372 234.202 947.704 228.604 950.224C223.006 952.743 220.781 959.695 223.761 965.353C226.741 971.012 234.032 973.68 239.63 971.16C245.228 968.641 247.454 961.689 244.474 956.031Z",
    fill: "url(#paint168_linear_78_5692)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M402.194 807.904C405.77 814.694 403.152 822.872 396.304 826.305C389.455 829.737 380.579 826.032 377.003 819.242C373.427 812.452 376.176 803.865 382.894 800.841C389.611 797.818 398.189 800.957 402.194 807.904ZM399.955 808.912C396.975 803.253 389.684 800.585 384.086 803.105C378.488 805.624 376.262 812.576 379.242 818.234C382.222 823.893 389.514 826.561 395.112 824.041C400.71 821.522 402.935 814.57 399.955 808.912Z",
    fill: "url(#paint169_linear_78_5692)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M254.187 880.739C257.763 887.528 255.014 896.114 248.298 899.137C241.581 902.16 232.576 898.864 229 892.075C225.425 885.286 228.042 877.109 234.89 873.678C241.606 870.655 250.183 873.793 254.187 880.739ZM251.948 881.746C248.969 876.089 241.679 873.421 236.082 875.94C230.484 878.46 228.259 885.41 231.239 891.068C234.218 896.725 241.509 899.393 247.106 896.874C252.703 894.354 254.928 887.404 251.948 881.746Z",
    fill: "url(#paint170_linear_78_5692)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M383.771 897.793C387.049 904.016 384.395 910.81 378.798 913.329C372.641 916.1 365.482 913.023 362.502 907.366C359.225 901.143 361.879 894.349 367.476 891.83C373.073 889.311 380.923 891.727 383.771 897.793ZM382.092 898.549C379.411 893.457 373.407 891.26 368.798 893.684C363.761 895.952 361.929 901.675 364.741 906.358C367.423 911.45 373.426 913.647 378.035 911.223C382.644 908.799 384.905 903.232 382.223 898.14L382.092 898.549Z",
    fill: "url(#paint171_linear_78_5692)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M430.011 1045.91C432.858 1051.97 430.634 1058.92 425.039 1061.44C419.015 1063.8 411.728 1061.13 408.75 1055.48C405.473 1049.25 407.697 1042.31 413.721 1039.95C419.745 1037.58 427.032 1040.25 430.011 1045.91ZM428.332 1046.66C425.652 1041.57 419.65 1039.38 414.615 1041.64C409.579 1043.91 407.747 1049.63 410.428 1054.72C413.109 1059.81 419.11 1062.01 424.146 1059.74C429.181 1057.47 431.013 1051.75 428.332 1046.66Z",
    fill: "url(#paint172_linear_78_5692)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M315.683 1104.14C318.662 1109.79 316.735 1117.31 310.712 1119.67C304.688 1122.03 297.4 1119.36 294.422 1113.71C291.146 1107.49 293.37 1100.54 299.394 1098.18C305.119 1095.25 312.705 1098.48 315.683 1104.14ZM314.005 1104.89C311.324 1099.8 305.323 1097.61 300.716 1100.03C295.68 1102.3 293.849 1108.02 296.529 1113.11C299.21 1118.2 305.342 1119.99 310.247 1118.13C315.152 1116.27 317.114 1110.14 314.303 1105.46L314.005 1104.89Z",
    fill: "url(#paint173_linear_78_5692)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M17.731 1249.03C22.7951 1258.65 19.2622 1269.69 9.88012 1273.56C0.367224 1277.84 -11.2085 1273.6 -15.8438 1264.15C-20.9078 1254.53 -17.3749 1243.49 -7.99289 1239.62C0.960428 1235.59 12.9649 1239.98 17.731 1249.03ZM14.9332 1250.29C10.7628 1242.38 1.33066 1238.92 -6.50349 1242.45C-14.3376 1245.98 -17.2163 1254.97 -13.0459 1262.89C-8.87556 1270.81 0.556572 1274.26 8.39072 1270.73C16.2249 1267.2 19.1036 1258.21 14.9332 1250.29Z",
    fill: "url(#paint174_linear_78_5692)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M167.593 1173.5C172.658 1183.12 169.124 1194.16 159.741 1198.03C150.227 1202.31 138.65 1198.08 134.014 1188.62C128.949 1179 132.483 1167.96 141.866 1164.09C151.249 1160.22 162.957 1164.04 167.593 1173.5ZM164.795 1174.76C160.624 1166.84 151.19 1163.39 143.355 1166.92C135.52 1170.44 132.641 1179.44 136.812 1187.36C140.983 1195.28 150.416 1198.73 158.251 1195.2C166.086 1191.68 168.965 1182.68 164.795 1174.76Z",
    fill: "url(#paint175_linear_78_5692)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M361.499 1035.69C366.564 1045.31 363.03 1056.34 353.647 1060.22C344.133 1064.5 332.556 1060.26 327.92 1050.8C322.855 1041.18 326.389 1030.15 335.772 1026.27C345.155 1022.4 356.863 1026.23 361.499 1035.69ZM358.701 1036.95C354.53 1029.03 345.097 1025.58 337.262 1029.1C329.427 1032.63 326.548 1041.62 330.718 1049.54C334.889 1057.46 344.323 1060.91 352.158 1057.39C359.993 1053.86 362.872 1044.87 358.701 1036.95Z",
    fill: "url(#paint176_linear_78_5692)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M407.294 926.567C412.358 936.181 408.825 947.216 399.444 951.088C389.933 955.37 378.489 950.726 373.723 941.677C368.66 932.062 372.192 921.028 381.573 917.155C390.954 913.283 402.529 917.518 407.294 926.567ZM404.497 927.826C400.327 919.909 390.896 916.458 383.063 919.983C375.229 923.509 372.351 932.5 376.521 940.418C380.691 948.335 390.122 951.786 397.955 948.261C405.788 944.735 408.667 935.744 404.497 927.826Z",
    fill: "url(#paint177_linear_78_5692)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-536.129 342.433H-408.203L-317.93 250.296L-226.295 250.296L-140.558 337.78L155.214 337.78L224.62 267.048H322.605V262.395H222.806L153.399 333.127L-138.743 333.127L-224.48 245.177L-319.744 245.177L-410.018 337.78H-536.129V342.433Z",
    fill: "url(#paint178_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.874 406.65L344.835 406.65L380.219 370.354H525.383V365.235H378.405L343.021 401.532L146.142 401.532L25.0214 277.751L-159.155 277.751L-243.078 191.663L-466.267 191.663L-503.466 230.286H-540.664V234.94H-501.651L-464.453 196.782L-244.893 196.782L-160.97 282.87L23.2068 282.87L143.874 406.65Z",
    fill: "url(#paint179_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-276.647 697.023L-194.539 697.023L-110.616 610.469H-3.55789L233.694 367.096H321.246V362.443H231.88L-5.37247 605.816H-112.431L-196.354 691.904L-276.647 691.904V697.023Z",
    fill: "url(#paint180_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-377.356 426.66H-258.049L-209.964 377.799L52.2383 377.799V368.027L-214.046 368.027L-262.132 416.888H-373.727L-434.514 354.532L-540.665 354.532V364.304L-438.597 364.304L-377.356 426.66Z",
    fill: "url(#paint181_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169.136 516.936H20.4844V512.283H-166.868L-225.84 451.788H-431.338L-469.443 412.7L-548.376 412.7V417.353L-471.258 417.353L-433.152 456.442L-228.109 456.907L-169.136 516.936Z",
    fill: "url(#paint182_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-303.412 606.281H-219.489L-40.3022 422.472L75.8289 422.472L162.02 510.887L444.182 510.887L492.267 559.747H559.859V549.975H495.897L447.811 501.114L165.649 501.114L79.9116 412.7L-44.3848 412.7L-223.571 596.975H-299.782L-337.888 557.421L-547.015 557.421V567.193L-341.971 567.193L-303.412 606.281Z",
    fill: "url(#paint183_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-194.993 583.015L114.841 583.015L256.829 437.363H421.953L421.499 427.591H253.2L110.758 573.708L-191.364 573.708L-257.595 505.303H-540.664V515.075H-261.678L-194.993 583.015Z",
    fill: "url(#paint184_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.523 616.984H559.859V612.331H457.337L387.477 540.668L185.609 540.668V545.322L385.209 545.322L455.523 616.984Z",
    fill: "url(#paint185_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-472.618 815.685L-111.977 815.685L-9.9086 710.518H174.268L246.396 636.529H319.432V631.875H244.582L172.453 705.864H-11.7232L-113.791 810.566L-470.35 810.566L-535.22 744.488H-557.902V749.141H-537.034L-472.618 815.685Z",
    fill: "url(#paint186_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-412.739 944.584L-108.803 944.584L-77.5018 912.476H87.6222L303.1 691.439H593.881L636.976 735.646L640.605 732.389L595.695 686.32H301.285L85.8076 907.357H-79.3162L-110.617 939.931L-410.925 939.465L-434.514 915.268H-553.367V920.386H-436.328L-412.739 944.584Z",
    fill: "url(#paint187_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.625 739.834H380.672V734.716H133.44L42.2589 641.182L-284.813 641.182L-388.696 534.619H-548.376V539.738H-390.511L-287.082 646.301L39.9905 646.301L131.625 739.834Z",
    fill: "url(#paint188_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.08 265.187C313.08 270.771 317.163 274.959 322.606 274.959C328.05 274.959 332.133 270.771 332.133 265.187C332.133 259.603 328.05 255.415 322.606 255.415C317.163 255.415 313.08 259.603 313.08 265.187Z",
    fill: "url(#paint189_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.904 367.096C309.904 372.215 313.987 376.869 319.431 376.869C324.874 376.869 328.957 372.681 328.957 367.096C328.957 361.512 324.874 357.324 319.431 357.324C313.987 357.324 309.904 361.512 309.904 367.096Z",
    fill: "url(#paint190_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.971 614.658C548.971 619.776 553.053 624.43 558.497 624.43C563.941 624.43 568.023 620.242 568.023 614.658C568.023 609.073 563.941 604.885 558.497 604.885C553.053 604.885 548.971 609.073 548.971 614.658Z",
    fill: "url(#paint191_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.535 542.995C176.535 548.579 180.618 552.767 186.062 552.767C191.505 552.767 195.588 548.579 195.588 542.995C195.588 537.411 191.505 533.223 186.062 533.223C180.618 533.223 176.535 537.411 176.535 542.995Z",
    fill: "url(#paint192_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.543 633.271C308.543 638.855 312.626 643.043 318.069 643.043C323.513 643.043 327.596 638.855 327.596 633.271C327.596 627.687 323.513 623.499 318.069 623.499C312.626 623.499 308.543 627.687 308.543 633.271Z",
    fill: "url(#paint193_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.305 691.439C291.305 696.558 295.387 701.211 300.831 701.211C306.275 701.211 310.357 697.023 310.357 691.439C310.357 685.855 306.275 681.667 300.831 681.667C295.387 681.667 291.305 685.855 291.305 691.439Z",
    fill: "url(#paint194_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.781 335.453C144.781 341.037 148.864 345.225 154.308 345.225C159.751 345.225 163.834 341.037 163.834 335.453C163.834 329.869 159.751 325.681 154.308 325.681C148.864 325.681 144.781 329.869 144.781 335.453Z",
    fill: "url(#paint195_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.504 513.213C10.504 518.797 14.5867 522.985 20.0303 522.985C25.474 522.985 29.5566 518.797 29.5566 513.213C29.5566 508.095 25.474 503.441 20.0303 503.441C14.5867 503.441 10.504 507.629 10.504 513.213Z",
    fill: "url(#paint196_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.533 734.716C631.533 740.3 635.616 744.488 641.06 744.488C646.503 744.488 650.586 740.3 650.586 734.716C650.586 729.131 646.503 724.943 641.06 724.943C635.616 724.943 631.533 729.131 631.533 734.716Z",
    fill: "url(#paint197_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.785 736.577C369.785 741.696 373.868 746.349 379.311 746.349C384.755 746.349 388.838 742.161 388.838 736.577C388.838 731.458 384.755 726.805 379.311 726.805C373.868 726.805 369.785 730.993 369.785 736.577Z",
    fill: "url(#paint198_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8261 643.974C31.8261 649.558 35.9089 653.746 41.3526 653.746C46.7962 653.746 50.8789 649.558 50.8789 643.974C50.8789 638.39 46.7962 634.202 41.3526 634.202C35.9089 634.202 31.8261 638.39 31.8261 643.974Z",
    fill: "url(#paint199_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.588 280.078C14.588 285.662 18.6707 289.85 24.1143 289.85C29.5579 289.85 33.6406 285.662 33.6406 280.078C33.6406 274.959 29.5579 270.305 24.1143 270.305C19.1243 270.305 14.588 274.493 14.588 280.078Z",
    fill: "url(#paint200_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.588 368.027C513.588 373.611 517.671 377.799 523.114 377.799C528.558 377.799 532.641 373.611 532.641 368.027C532.641 362.443 528.558 358.255 523.114 358.255C517.671 358.255 513.588 362.443 513.588 368.027Z",
    fill: "url(#paint201_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.437 432.244C407.437 439.689 413.334 445.739 420.593 445.739C427.851 445.739 433.748 439.689 433.748 432.244C433.748 424.798 427.851 418.749 420.593 418.749C413.334 418.749 407.437 424.798 407.437 432.244Z",
    fill: "url(#paint202_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7217 373.146C37.7217 380.591 43.6191 386.641 50.8773 386.641C58.1354 386.641 64.4863 380.591 64.4863 373.146C64.4863 365.701 58.5891 359.651 50.8773 359.651C43.1654 359.651 37.7217 365.701 37.7217 373.146Z",
    fill: "url(#paint203_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.517 556.025C548.517 563.47 554.415 569.519 561.673 569.519C568.931 569.519 574.828 563.47 574.828 556.025C574.828 548.579 568.931 542.53 561.673 542.53C554.415 542.53 548.517 548.579 548.517 556.025Z",
    fill: "url(#paint204_linear_78_5692)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-384.16 394.086H-289.803L-223.118 325.681L-155.527 325.681L-92.0175 390.829L127.089 390.829L177.897 338.245H250.479V334.522H176.536L125.275 387.106L-90.6564 387.106L-153.712 322.424L-224.479 322.424L-291.164 390.363H-384.16V394.086Z",
    fill: "url(#paint205_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.471 441.551L267.264 441.551L293.121 414.561H400.633V411.304H291.76L265.449 437.828L119.832 437.828L30.4651 346.156L-105.626 346.156L-167.774 282.405L-332.898 282.405L-360.57 311.256H-387.788V314.513H-358.755L-331.084 286.127L-169.135 286.127L-106.987 349.879L29.1042 349.879L118.471 441.551Z",
    fill: "url(#paint206_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-192.27 656.073H-131.936L-69.7881 592.321H9.59834L185.156 412.234H249.572V408.512H183.795L8.23749 588.599H-71.149L-133.297 652.816H-192.27V656.073Z",
    fill: "url(#paint207_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-267.121 456.442H-178.661L-143.278 420.145L50.4252 420.145L50.8789 412.7L-145.999 412.7L-181.837 449.462H-264.399L-309.309 402.928L-387.788 402.928V410.373L-312.484 410.373L-267.121 456.442Z",
    fill: "url(#paint208_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-112.885 522.985H27.2891V519.728H-111.524L-155.073 475.055H-307.041L-335.167 445.739L-393.686 445.739V449.462L-336.528 449.462L-308.402 478.313H-156.434L-112.885 522.985Z",
    fill: "url(#paint209_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-212.684 589.529H-150.536L-17.6203 453.184L68.1172 453.184L131.626 518.332H340.753L376.137 554.629H426.49V547.649H378.858L343.475 511.352L134.802 511.352L70.8389 445.739L-20.7957 445.739L-153.258 582.084H-209.509L-238.088 553.233L-392.324 553.233V560.213L-240.81 560.213L-212.684 589.529Z",
    fill: "url(#paint210_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-132.39 572.312L96.6966 572.312L201.94 464.353H323.969V456.907H199.219L93.9749 564.866L-129.215 564.866L-178.661 514.61H-387.788V521.59H-181.383L-132.39 572.312Z",
    fill: "url(#paint211_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.918 597.44H426.49V593.717H350.279L298.565 540.668H149.318V543.926H297.204L348.918 597.44Z",
    fill: "url(#paint212_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-337.434 744.022L-70.6957 744.022L4.608 666.311H141.153L194.228 611.4H248.211V608.143H192.867L139.338 662.588H3.24715L-72.0566 740.3L-336.073 740.3L-383.705 691.439H-400.49V695.162H-385.066L-337.434 744.022Z",
    fill: "url(#paint213_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-293.432 839.417L-68.4277 839.417L-45.2922 815.685H76.7361L236.416 651.885H450.986L483.195 684.924L485.463 682.597L452.801 648.628H234.602L75.3752 811.962H-46.6532L-69.7886 835.695L-291.617 835.695L-309.309 818.012H-397.314V821.269H-310.67L-293.432 839.417Z",
    fill: "url(#paint214_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.398 687.716H293.574V684.459H110.759L43.1666 615.123L-198.622 615.123L-275.286 536.48H-393.686V539.738H-277.101L-200.436 618.846L41.8058 618.846L109.398 687.716Z",
    fill: "url(#paint215_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.674 336.849C243.674 341.037 246.85 343.829 250.479 343.829C254.108 343.829 257.283 340.572 257.283 336.849C257.283 333.127 254.108 329.869 250.479 329.869C246.85 329.869 243.674 333.127 243.674 336.849Z",
    fill: "url(#paint216_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.407 412.235C241.407 415.957 244.582 419.215 248.211 419.215C251.84 419.215 255.016 415.957 255.016 412.235C255.016 408.512 251.84 405.255 248.211 405.255C244.582 405.255 241.407 408.512 241.407 412.235Z",
    fill: "url(#paint217_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.325 595.578C418.325 599.301 421.5 602.559 425.129 602.559C428.758 602.559 431.934 599.301 431.934 595.578C431.934 591.39 428.758 588.598 425.129 588.598C421.5 588.598 418.325 591.856 418.325 595.578Z",
    fill: "url(#paint218_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.514 542.065C142.514 546.253 145.689 549.045 149.318 549.51C153.401 549.51 156.123 546.253 156.123 542.065C156.123 537.877 152.948 535.084 149.318 535.084C145.689 535.084 142.514 538.342 142.514 542.065Z",
    fill: "url(#paint219_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.045 609.074C240.045 613.262 243.221 616.054 246.85 616.054C250.479 616.054 253.654 612.796 253.654 609.074C253.654 604.886 250.479 602.094 246.85 602.094C243.221 602.094 240.045 605.351 240.045 609.074Z",
    fill: "url(#paint220_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.343 651.885C227.343 656.073 230.519 658.865 234.148 658.865C237.777 658.865 241.406 655.608 241.406 651.885C241.406 648.162 238.231 644.905 234.148 644.905C230.065 644.905 227.343 648.162 227.343 651.885Z",
    fill: "url(#paint221_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.379 388.967C119.379 393.155 122.554 395.947 126.183 395.947C129.812 395.947 132.988 392.69 133.441 388.967C133.441 385.245 130.266 381.987 126.183 381.987C122.1 381.987 119.379 385.245 119.379 388.967Z",
    fill: "url(#paint222_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0316 520.193C20.0316 523.916 23.2071 527.174 26.8362 527.174C30.4653 527.174 33.6406 523.916 33.6406 520.193C33.6406 516.005 30.4653 513.213 26.8362 513.213C23.2071 513.213 20.0316 516.471 20.0316 520.193Z",
    fill: "url(#paint223_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.55829 664.449C-3.55829 668.172 -0.382764 671.429 3.24633 671.429C6.87543 671.429 10.0508 668.172 10.0508 664.449C10.0508 660.726 6.87543 657.469 3.24633 657.469C-0.382764 657.469 -3.55829 660.726 -3.55829 664.449Z",
    fill: "url(#paint224_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.112 684.459C479.112 688.182 482.287 691.439 485.916 691.439C489.545 691.439 492.721 688.182 492.721 684.459C492.721 680.271 489.545 677.479 485.916 677.479C482.287 677.479 479.112 680.736 479.112 684.459Z",
    fill: "url(#paint225_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.408 685.389C285.408 689.112 288.584 692.37 292.213 692.37C295.842 692.37 299.018 689.112 299.018 685.389C299.018 681.201 295.842 678.409 292.213 678.409C288.584 678.409 285.408 681.667 285.408 685.389Z",
    fill: "url(#paint226_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4548 616.984C35.4548 620.707 38.6303 623.964 42.2594 623.964C45.8885 623.964 49.5176 620.707 49.5176 616.519C49.5176 612.331 46.3421 609.539 42.713 609.539C39.0839 609.539 35.9083 612.796 35.9083 616.519L35.4548 616.984Z",
    fill: "url(#paint227_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2073 348.017C23.2073 351.74 26.3829 354.997 30.012 354.997C33.6411 354.997 36.8164 351.74 36.8164 348.017C36.8164 344.295 33.6411 341.037 30.012 341.037C26.3829 341.037 22.7538 344.295 22.7538 348.017H23.2073Z",
    fill: "url(#paint228_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.014 412.7C392.014 416.888 395.189 420.145 398.819 419.68C402.448 419.68 405.623 416.423 405.623 412.7C405.623 408.977 402.448 405.72 398.819 405.72C395.189 405.72 392.014 408.977 392.014 412.7Z",
    fill: "url(#paint229_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.534 460.63C313.534 466.214 318.07 470.867 323.514 470.867C328.958 470.867 333.494 466.214 333.494 460.63C333.494 455.046 328.958 450.392 323.514 450.392C318.07 450.392 313.534 455.046 313.534 460.63Z",
    fill: "url(#paint230_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.991 416.888C39.991 422.472 44.5275 427.125 49.9711 427.125C55.4147 427.125 59.9512 422.472 59.9512 416.888C59.9512 411.304 55.4147 407.116 49.9711 407.116C44.5275 407.116 39.991 411.769 39.991 417.353V416.888Z",
    fill: "url(#paint231_linear_78_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.417 551.837C417.417 557.421 421.953 562.074 427.397 562.074C432.841 562.074 437.377 557.421 437.377 551.837C437.377 546.252 432.841 541.599 427.397 541.599C421.953 541.599 417.417 546.252 417.417 551.837Z",
    fill: "url(#paint232_linear_78_5692)"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M-329.723 412.7H-247.161L-189.096 353.136H-129.669L-74.3256 409.908L116.656 409.908L161.566 363.839H224.621V361.047H160.205L115.295 406.65L-73.4183 406.65L-128.762 349.879H-190.003L-248.522 409.442H-329.723V412.7Z",
    fill: "url(#paint233_linear_78_5692)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M109.398 454.115L239.138 454.115L261.82 430.848H355.723V427.591H260.459L237.777 450.858L110.759 450.858L32.7331 371.285L-86.5733 371.285L-140.556 315.444H-284.813L-308.855 340.107H-332.898V343.364H-307.495L-283.452 318.701H-141.917L-87.4806 374.077L31.3722 374.077L109.398 454.115Z",
    fill: "url(#paint234_linear_78_5692)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M-162.33 641.647L-109.255 641.647L-54.8183 585.806H14.1345L167.464 428.521H223.715V425.729H166.103L12.7737 582.549H-56.1792L-110.616 638.39L-162.33 638.39V641.647Z",
    fill: "url(#paint235_linear_78_5692)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M-227.201 467.145H-150.083L-119.236 435.501L49.9707 435.501V428.987L-121.958 428.987L-152.805 461.095H-224.933L-264.4 420.611H-332.899V426.66H-266.668L-227.201 467.145Z",
    fill: "url(#paint236_linear_78_5692)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M-92.9254 525.312H29.5566V522.52H-91.5643L-129.67 483.432H-262.132L-286.628 457.838H-337.889V461.095H-287.989L-263.493 486.224L-131.031 486.689L-92.9254 525.312Z",
    fill: "url(#paint237_linear_78_5692)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M-179.571 583.014H-125.588L-9.45673 464.353H65.3934L120.737 521.124H303.099L333.946 553.233H377.949V546.718H336.668L305.821 515.075H123.459L67.6616 457.838H-12.1784L-127.856 576.965H-177.302L-201.799 551.371H-336.982V557.886H-204.521L-179.571 583.014Z",
    fill: "url(#paint238_linear_78_5692)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M-109.709 568.123L90.3447 568.123L182.433 474.125H288.584V467.61H179.711L88.0766 562.074L-106.987 562.074L-150.083 517.867H-332.898V524.381H-152.351L-109.709 568.123Z",
    fill: "url(#paint239_linear_78_5692)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M310.357 589.995H377.949V586.737H311.718L266.355 540.668H136.614V543.926H264.994L310.357 589.995Z",
    fill: "url(#paint240_linear_78_5692)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M-288.896 717.963L-56.1801 717.963L10.0509 650.489H128.904L175.628 602.559H222.807V599.301H174.268L127.543 647.231H8.69L-57.0874 715.171L-287.535 715.171L-329.269 672.36H-343.786V675.617H-330.177L-288.896 717.963Z",
    fill: "url(#paint241_linear_78_5692)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M-250.336 801.725H-53.9114L-33.4977 780.784H73.1069L211.92 637.925H399.725L427.851 666.776L430.119 664.449L401.086 634.667L211.012 635.133L71.746 777.527H-34.8586L-55.2722 798.467H-248.975L-263.945 782.646L-341.063 782.646V785.903L-265.306 785.903L-250.336 801.725Z",
    fill: "url(#paint242_linear_78_5692)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M101.232 669.102H262.273V666.31H102.593L43.6205 605.816L-167.774 605.816L-234.459 536.946H-337.888V540.203H-235.82L-168.682 608.608L42.2596 608.608L101.232 669.102Z",
    fill: "url(#paint243_linear_78_5692)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M218.723 362.908C218.723 366.166 221.445 368.958 224.62 368.958C227.796 368.958 230.518 366.166 230.518 362.908C230.518 359.651 227.796 356.859 224.62 356.859C221.445 356.859 218.269 359.651 218.723 362.908Z",
    fill: "url(#paint244_linear_78_5692)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M216.456 428.521C216.456 431.779 219.177 434.571 222.353 434.571C225.528 434.571 228.25 431.779 228.25 428.521C228.25 425.264 225.528 422.472 222.353 422.472C219.177 422.472 216.456 425.264 216.456 428.521Z",
    fill: "url(#paint245_linear_78_5692)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M371.145 588.598C371.145 591.856 373.867 594.648 377.042 594.648C380.218 594.648 382.939 591.856 382.939 588.598C382.939 584.876 380.218 582.549 376.589 582.549C372.959 582.549 370.691 585.341 370.691 588.598H371.145Z",
    fill: "url(#paint246_linear_78_5692)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M130.264 542.064C130.264 545.787 132.986 548.579 136.161 548.114C139.337 548.114 142.059 545.322 142.059 542.064C142.059 538.807 139.337 536.015 136.161 536.015C132.986 536.015 130.264 538.807 130.264 542.064Z",
    fill: "url(#paint247_linear_78_5692)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M215.547 600.697C215.547 604.42 218.269 606.747 221.444 606.747C224.62 606.747 227.342 603.955 227.342 600.697C227.342 597.44 224.62 594.648 221.444 594.648C218.269 594.648 215.547 597.44 215.547 600.697Z",
    fill: "url(#paint248_linear_78_5692)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M204.66 637.924C204.66 641.182 207.382 643.974 210.558 643.974C213.733 643.974 216.455 641.182 216.455 637.924C216.455 634.667 213.733 631.875 210.558 631.875C207.382 631.875 204.66 634.667 204.66 637.924Z",
    fill: "url(#paint249_linear_78_5692)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M109.85 408.046C109.85 411.769 112.572 414.096 115.747 414.096C118.923 414.096 121.645 411.304 121.645 408.046C121.645 404.789 118.923 401.997 115.747 401.997C112.572 401.997 109.396 404.789 109.396 408.046H109.85Z",
    fill: "url(#paint250_linear_78_5692)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2053 522.986C23.2053 526.243 25.9272 529.035 29.1027 529.035C32.2781 529.035 35 526.243 35 522.986C35 519.728 32.2781 516.936 29.1027 516.936C25.9272 516.936 23.2053 519.728 23.2053 522.986Z",
    fill: "url(#paint251_linear_78_5692)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79323 648.627C2.79323 651.885 5.5151 654.677 8.69056 654.677C11.866 654.677 14.5879 651.885 14.5879 648.627C14.5879 645.37 11.866 642.578 8.69056 642.578C5.06147 642.578 2.3396 645.37 2.79323 648.627Z",
    fill: "url(#paint252_linear_78_5692)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M424.221 666.31C424.221 669.568 426.943 672.36 430.118 672.36C433.294 672.36 436.016 669.568 436.016 666.31C436.016 663.053 433.294 660.261 430.118 660.261C426.943 660.261 424.221 663.053 424.221 666.31Z",
    fill: "url(#paint253_linear_78_5692)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M255.014 667.241C255.014 670.498 257.736 673.29 260.911 673.29C264.087 673.29 266.809 670.498 266.809 667.241C266.809 663.984 264.087 661.192 260.911 661.192C257.736 661.192 255.014 663.984 255.014 667.241Z",
    fill: "url(#paint254_linear_78_5692)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8147 607.212C36.8147 610.469 39.5366 613.261 42.712 613.261C45.8875 613.261 48.6094 610.469 48.6094 607.212C48.6094 603.955 45.8876 601.163 42.2585 601.163C38.6294 601.163 36.3612 603.955 36.3612 607.212H36.8147Z",
    fill: "url(#paint255_linear_78_5692)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9282 372.68C25.9282 375.938 28.6499 378.73 31.8253 378.73C35.0008 378.73 37.7227 375.938 37.7227 372.68C37.7227 369.423 35.0008 366.631 31.8253 366.631C28.6499 366.631 25.9282 369.423 25.9282 372.68Z",
    fill: "url(#paint256_linear_78_5692)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M348.01 428.986C348.01 432.244 350.732 435.036 353.907 435.036C357.083 435.036 359.805 432.244 359.805 428.986C359.805 425.729 357.083 422.937 353.907 422.937C350.732 422.937 348.01 425.729 348.01 428.986Z",
    fill: "url(#paint257_linear_78_5692)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M279.512 470.867C279.512 475.986 283.141 479.709 288.131 479.709C293.121 479.709 296.75 475.986 296.75 470.867C296.75 465.749 292.667 462.026 288.131 462.026C283.595 462.026 279.512 465.749 279.512 470.867Z",
    fill: "url(#paint258_linear_78_5692)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8985 432.709C40.8985 437.828 44.5277 441.551 49.5177 441.551C54.5077 441.551 58.1367 437.828 58.1367 432.709C58.1367 427.59 54.5077 423.868 49.5177 423.868C44.5277 423.868 40.8985 427.59 40.8985 432.709Z",
    fill: "url(#paint259_linear_78_5692)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M370.691 550.44C370.691 555.559 374.32 559.282 379.31 559.282C384.3 559.282 387.93 555.559 387.93 550.44C387.93 545.322 384.3 541.599 379.31 541.599C374.32 541.599 370.691 545.787 370.691 550.44Z",
    fill: "url(#paint260_linear_78_5692)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M-12.6316 360.581C-20.3434 360.581 -27.148 354.067 -27.148 345.691C-27.148 337.314 -20.7971 330.8 -12.6316 330.8C-4.46614 330.8 1.88477 337.314 1.88477 345.691C1.88477 354.067 -4.46614 360.581 -12.6316 360.581ZM-12.6316 333.592C-18.9825 333.592 -24.4261 339.176 -24.4261 345.691C-24.4261 352.205 -18.9825 357.789 -12.6316 357.789C-6.28068 357.789 -0.836945 352.205 -0.836945 345.691C-0.836945 339.176 -6.28068 333.592 -12.6316 333.592Z",
    fill: "url(#paint261_linear_78_5692)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M224.167 376.403C216.455 376.403 209.651 369.888 209.651 361.512C209.651 353.136 216.002 346.621 224.167 346.621C232.333 346.621 238.684 353.136 238.684 361.512C238.684 369.888 232.333 376.403 224.167 376.403ZM224.167 349.413C217.363 349.413 212.373 354.998 212.373 361.512C212.373 368.027 217.816 373.611 224.167 373.611C230.518 373.611 235.962 368.027 235.962 361.512C235.962 354.998 230.518 349.413 224.167 349.413Z",
    fill: "url(#paint262_linear_78_5692)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M222.806 615.588C215.094 615.588 208.29 609.074 208.29 600.697C208.29 592.321 214.64 585.807 222.806 585.807C230.971 585.807 237.322 592.321 237.322 600.697C237.322 609.074 230.971 615.588 222.806 615.588ZM222.806 588.599C216.455 588.599 211.011 594.183 211.011 600.697C211.011 607.212 216.455 612.796 222.806 612.796C229.157 612.796 234.6 607.212 234.6 600.697C234.6 594.183 229.157 588.599 222.806 588.599Z",
    fill: "url(#paint263_linear_78_5692)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M431.027 679.805C423.315 679.805 416.51 673.291 416.51 664.914C416.51 656.538 422.861 650.024 431.027 650.024C439.192 650.024 445.543 656.538 445.543 664.914C445.543 673.291 439.192 679.805 431.027 679.805ZM431.027 652.816C424.222 652.816 419.232 658.4 419.232 664.914C419.232 671.429 424.676 677.013 431.027 677.013C437.378 677.013 442.821 671.429 442.821 664.914C442.821 658.4 437.378 652.816 431.027 652.816Z",
    fill: "url(#paint264_linear_78_5692)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M262.273 681.667C254.107 681.667 247.756 675.152 247.756 666.776C247.756 658.4 254.107 651.885 262.273 651.885C270.438 651.885 276.789 658.4 276.789 666.776C276.789 675.152 270.438 681.667 262.273 681.667ZM262.273 654.677C255.922 654.677 250.478 660.261 250.478 666.776C250.478 673.29 255.922 678.875 262.273 678.875C268.624 678.875 274.067 673.29 274.067 666.776C274.067 660.261 268.624 654.677 262.273 654.677Z",
    fill: "url(#paint265_linear_78_5692)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M376.59 601.628C369.785 601.628 364.341 596.044 364.341 589.064C364.341 582.084 369.785 576.5 376.59 576.5C383.394 576.5 388.838 582.084 388.838 589.064C388.838 596.044 383.394 601.628 376.59 601.628ZM376.59 578.826C371.146 578.826 366.61 583.48 366.61 589.064C366.61 594.648 371.146 599.301 376.59 599.301C382.033 599.301 386.57 594.648 386.57 589.064C386.57 583.48 382.033 578.826 376.59 578.826Z",
    fill: "url(#paint266_linear_78_5692)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M354.361 441.086C347.557 441.086 342.113 435.501 342.113 428.521C342.113 421.541 347.557 415.957 354.361 415.957C361.166 415.957 366.609 421.541 366.609 428.521C366.609 435.501 361.166 441.086 354.361 441.086ZM354.361 418.284C348.918 418.284 344.381 422.937 344.381 428.521C344.381 434.105 348.918 438.759 354.361 438.759C359.805 438.759 364.341 434.105 364.341 428.521C364.341 422.937 359.805 418.284 354.361 418.284Z",
    fill: "url(#paint267_linear_78_5692)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M223.26 440.62C216.455 440.62 211.011 435.036 211.011 428.056C211.011 421.076 216.455 415.492 223.26 415.492C230.064 415.492 235.508 421.076 235.508 428.056C235.508 435.036 230.064 440.62 223.26 440.62ZM223.26 417.819C217.816 417.819 213.28 422.472 213.28 428.056C213.28 433.64 217.816 438.294 223.26 438.294C228.703 438.294 233.24 433.64 233.24 428.056C233.24 422.472 228.703 417.819 223.26 417.819Z",
    fill: "url(#paint268_linear_78_5692)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0639 453.649C38.1766 453.649 29.5575 444.808 29.5575 433.64C29.5575 422.472 38.1766 413.63 49.0639 413.63C59.9512 413.63 68.5703 422.472 68.5703 433.64C68.5703 444.808 59.9513 453.649 49.5176 453.649H49.0639ZM49.0639 417.353C40.4448 417.353 33.1867 424.798 33.1867 433.64C33.1867 442.481 40.4448 449.927 49.0639 449.927C57.683 449.927 64.9413 442.481 64.9413 433.64C64.9413 424.798 57.683 417.353 49.0639 417.353Z",
    fill: "url(#paint269_linear_78_5692)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M288.584 490.412C278.151 490.412 269.078 481.57 269.078 470.402C269.078 459.234 277.697 450.392 288.584 450.392C299.472 450.392 308.091 459.234 307.637 470.402C307.637 481.105 299.018 490.412 288.584 490.412ZM288.584 454.115C279.965 454.115 272.707 461.56 272.707 470.402C272.707 479.243 279.965 486.689 288.584 486.689C297.203 486.689 304.462 479.243 304.462 470.402C304.462 461.56 297.203 454.115 288.584 454.115Z",
    fill: "url(#paint270_linear_78_5692)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M378.404 571.381C367.971 571.381 358.898 562.539 358.898 551.371C358.898 540.203 367.517 531.362 377.951 531.362C388.384 531.362 397.457 540.203 397.457 551.371C397.457 562.539 388.838 571.381 377.951 571.381H378.404ZM378.404 535.084C369.785 535.084 362.527 542.53 362.527 551.371C362.527 560.213 369.785 567.658 378.404 567.658C387.023 567.658 394.282 560.213 394.282 551.371C394.282 542.53 387.023 535.084 378.404 535.084Z",
    fill: "url(#paint271_linear_78_5692)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_5692",
    x1: 740.878,
    y1: -26.637,
    x2: -267.296,
    y2: -533.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_78_5692",
    x1: 748.301,
    y1: -10.4953,
    x2: -276.282,
    y2: -524.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_78_5692",
    x1: 634.214,
    y1: 190.448,
    x2: -339.506,
    y2: -309.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_78_5692",
    x1: 706.092,
    y1: 54.3839,
    x2: -310.395,
    y2: -455.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_78_5692",
    x1: 688.512,
    y1: 124.34,
    x2: -339.759,
    y2: -391.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_78_5692",
    x1: 662.489,
    y1: 181.82,
    x2: -351.794,
    y2: -327.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_78_5692",
    x1: 655.594,
    y1: 171.399,
    x2: -353.158,
    y2: -335.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_78_5692",
    x1: 635.907,
    y1: 274.716,
    x2: -393.746,
    y2: -242.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_78_5692",
    x1: 567.202,
    y1: 366.694,
    x2: -437.975,
    y2: -138.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_78_5692",
    x1: 533.934,
    y1: 463.788,
    x2: -469.227,
    y2: -40.7798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_78_5692",
    x1: 620.701,
    y1: 296.452,
    x2: -410.884,
    y2: -221.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_78_5692",
    x1: 618.025,
    y1: 320.381,
    x2: -396.553,
    y2: -188.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_78_5692",
    x1: 647.018,
    y1: 226.239,
    x2: -368.699,
    y2: -283.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_78_5692",
    x1: 610.732,
    y1: 319.228,
    x2: -403.47,
    y2: -189.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_78_5692",
    x1: 588.209,
    y1: 371.326,
    x2: -426.941,
    y2: -138.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_78_5692",
    x1: 581.472,
    y1: 362.86,
    x2: -433.178,
    y2: -145.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_78_5692",
    x1: 571.04,
    y1: 437.266,
    x2: -443.014,
    y2: -71.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_78_5692",
    x1: 570.058,
    y1: 418.941,
    x2: -444.148,
    y2: -90.0263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_78_5692",
    x1: 605.668,
    y1: 308.09,
    x2: -407.154,
    y2: -200.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_78_5692",
    x1: 715.06,
    y1: 90.539,
    x2: -299.144,
    y2: -418.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_78_5692",
    x1: 690.099,
    y1: 142.047,
    x2: -324.883,
    y2: -366.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_78_5692",
    x1: 641.538,
    y1: 266.525,
    x2: -374.975,
    y2: -243.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_78_5692",
    x1: 715.47,
    y1: 35.4152,
    x2: -292.746,
    y2: -470.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_78_5692",
    x1: 723.108,
    y1: 48.2481,
    x2: -301.482,
    y2: -466.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_78_5692",
    x1: 632.92,
    y1: 193.643,
    x2: -340.278,
    y2: -306.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_78_5692",
    x1: 691.098,
    y1: 95.7415,
    x2: -325.313,
    y2: -414.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_78_5692",
    x1: 679.642,
    y1: 148.195,
    x2: -348.562,
    y2: -368.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_78_5692",
    x1: 658.656,
    y1: 190.282,
    x2: -355.604,
    y2: -318.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_78_5692",
    x1: 652.679,
    y1: 182.053,
    x2: -356.057,
    y2: -324.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_78_5692",
    x1: 640.982,
    y1: 259.634,
    x2: -388.635,
    y2: -257.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_78_5692",
    x1: 586.584,
    y1: 326.151,
    x2: -418.134,
    y2: -179.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_78_5692",
    x1: 562.176,
    y1: 398.237,
    x2: -440.982,
    y2: -106.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_78_5692",
    x1: 629.988,
    y1: 275.81,
    x2: -401.73,
    y2: -243.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_78_5692",
    x1: 625.921,
    y1: 292.575,
    x2: -389.423,
    y2: -216.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_78_5692",
    x1: 646.319,
    y1: 222.546,
    x2: -367.32,
    y2: -286.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_78_5692",
    x1: 620.481,
    y1: 291.921,
    x2: -394.292,
    y2: -217.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_78_5692",
    x1: 603.054,
    y1: 330.102,
    x2: -410.585,
    y2: -178.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_78_5692",
    x1: 599.161,
    y1: 324.246,
    x2: -416.187,
    y2: -185.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_78_5692",
    x1: 590.989,
    y1: 378.961,
    x2: -423.791,
    y2: -130.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_78_5692",
    x1: 590.448,
    y1: 365.616,
    x2: -424.331,
    y2: -143.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_78_5692",
    x1: 617.378,
    y1: 283.786,
    x2: -397.397,
    y2: -225.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_78_5692",
    x1: 697.475,
    y1: 122.412,
    x2: -316.735,
    y2: -386.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_78_5692",
    x1: 678.649,
    y1: 160.601,
    x2: -335.363,
    y2: -348.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_78_5692",
    x1: 642.919,
    y1: 252.77,
    x2: -371.525,
    y2: -256.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_78_5692",
    x1: 706.423,
    y1: 57.715,
    x2: -301.651,
    y2: -448.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_78_5692",
    x1: 714.441,
    y1: 69.6334,
    x2: -310.166,
    y2: -444.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_78_5692",
    x1: 632.929,
    y1: 194.911,
    x2: -340.835,
    y2: -304.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_78_5692",
    x1: 685.37,
    y1: 110.684,
    x2: -330.963,
    y2: -398.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_78_5692",
    x1: 676.467,
    y1: 156.957,
    x2: -351.943,
    y2: -359.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_78_5692",
    x1: 657.357,
    y1: 193.011,
    x2: -356.933,
    y2: -316.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_78_5692",
    x1: 651.651,
    y1: 185.87,
    x2: -357.078,
    y2: -320.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_78_5692",
    x1: 643.02,
    y1: 253.857,
    x2: -386.664,
    y2: -263.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_78_5692",
    x1: 593.698,
    y1: 311.672,
    x2: -411.097,
    y2: -193.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_78_5692",
    x1: 572.065,
    y1: 374.228,
    x2: -431.099,
    y2: -130.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_78_5692",
    x1: 633.426,
    y1: 268.189,
    x2: -398.171,
    y2: -250.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_78_5692",
    x1: 628.341,
    y1: 282.48,
    x2: -385.295,
    y2: -226.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_78_5692",
    x1: 646.898,
    y1: 221.803,
    x2: -367.875,
    y2: -287.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_78_5692",
    x1: 623.828,
    y1: 282.116,
    x2: -391.072,
    y2: -227.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_78_5692",
    x1: 608.472,
    y1: 315.594,
    x2: -404.719,
    y2: -193.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_78_5692",
    x1: 629.818,
    y1: 245.008,
    x2: -383.698,
    y2: -263.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_78_5692",
    x1: 604.948,
    y1: 310.331,
    x2: -409.829,
    y2: -198.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_78_5692",
    x1: 597.788,
    y1: 357.965,
    x2: -416.418,
    y2: -151.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_78_5692",
    x1: 597.098,
    y1: 346.038,
    x2: -416.538,
    y2: -162.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_78_5692",
    x1: 620.809,
    y1: 274.917,
    x2: -393.52,
    y2: -234.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_78_5692",
    x1: 691.433,
    y1: 133.985,
    x2: -323.787,
    y2: -375.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_78_5692",
    x1: 675.402,
    y1: 167.665,
    x2: -340.781,
    y2: -341.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_78_5692",
    x1: 643.529,
    y1: 247.932,
    x2: -371.248,
    y2: -261.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_78_5692",
    x1: 623.406,
    y1: 291.648,
    x2: -411.857,
    y2: -205.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_78_5692",
    x1: 598.289,
    y1: 361.213,
    x2: -436.833,
    y2: -135.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_78_5692",
    x1: 597.699,
    y1: 354.708,
    x2: -438.005,
    y2: -142.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_78_5692",
    x1: 628.082,
    y1: 288.726,
    x2: -407.043,
    y2: -208.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_78_5692",
    x1: 691.261,
    y1: 139.793,
    x2: -343.861,
    y2: -357.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_78_5692",
    x1: 691.907,
    y1: 132.158,
    x2: -344.05,
    y2: -364.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_78_5692",
    x1: 674.691,
    y1: 175.135,
    x2: -361.014,
    y2: -322.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_78_5692",
    x1: 643.286,
    y1: 254.117,
    x2: -392.419,
    y2: -243.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_78_5692",
    x1: 752.206,
    y1: 1204.07,
    x2: -374.37,
    y2: 1826.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_78_5692",
    x1: 702.046,
    y1: 1106.88,
    x2: -411.983,
    y2: 1723.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_78_5692",
    x1: 709.391,
    y1: 1090.46,
    x2: -424.273,
    y2: 1717.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_78_5692",
    x1: 592.479,
    y1: 905.441,
    x2: -478.121,
    y2: 1514.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_78_5692",
    x1: 665.999,
    y1: 1031.26,
    x2: -458.132,
    y2: 1653.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_78_5692",
    x1: 647.509,
    y1: 965.42,
    x2: -490.663,
    y2: 1595.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_78_5692",
    x1: 620.774,
    y1: 910.748,
    x2: -500.617,
    y2: 1531.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_78_5692",
    x1: 613.935,
    y1: 921.216,
    x2: -501.318,
    y2: 1538.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_78_5692",
    x1: 593.115,
    y1: 821.816,
    x2: -546.542,
    y2: 1453.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_78_5692",
    x1: 522.434,
    y1: 739.811,
    x2: -587.956,
    y2: 1355.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_78_5692",
    x1: 487.985,
    y1: 647.677,
    x2: -619.917,
    y2: 1262.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_78_5692",
    x1: 577.353,
    y1: 803.532,
    x2: -564.727,
    y2: 1436.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_78_5692",
    x1: 717.168,
    y1: 1096.32,
    x2: -404.288,
    y2: 1716.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_78_5692",
    x1: 676.464,
    y1: 1009.18,
    x2: -447.631,
    y2: 1631.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_78_5692",
    x1: 574.83,
    y1: 777.816,
    x2: -545.738,
    y2: 1398.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_78_5692",
    x1: 603.687,
    y1: 868.553,
    x2: -516.781,
    y2: 1488.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_78_5692",
    x1: 567.742,
    y1: 780.571,
    x2: -555.196,
    y2: 1401.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_78_5692",
    x1: 544.412,
    y1: 732.003,
    x2: -579.662,
    y2: 1353.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_78_5692",
    x1: 688.36,
    y1: 1049.07,
    x2: -432.569,
    y2: 1669.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_78_5692",
    x1: 617.05,
    y1: 906.175,
    x2: -506.618,
    y2: 1528.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_78_5692",
    x1: 526.051,
    y1: 668.495,
    x2: -596.916,
    y2: 1289.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_78_5692",
    x1: 525.069,
    y1: 687.285,
    x2: -595.326,
    y2: 1307.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_78_5692",
    x1: 561.964,
    y1: 793.046,
    x2: -557.84,
    y2: 1412.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_78_5692",
    x1: 675.76,
    y1: 992.858,
    x2: -446.224,
    y2: 1613.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_78_5692",
    x1: 649.448,
    y1: 945.225,
    x2: -474.351,
    y2: 1567.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_78_5692",
    x1: 674.684,
    y1: 1024.04,
    x2: -450.072,
    y2: 1646.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_78_5692",
    x1: 599.045,
    y1: 828.462,
    x2: -524.332,
    y2: 1449.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_78_5692",
    x1: 714.177,
    y1: 1119.72,
    x2: -412.047,
    y2: 1742.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_78_5692",
    x1: 675.854,
    y1: 1048.29,
    x2: -438.176,
    y2: 1665.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_78_5692",
    x1: 683.5,
    y1: 1035.11,
    x2: -450.206,
    y2: 1662.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_78_5692",
    x1: 591.717,
    y1: 902.176,
    x2: -479.395,
    y2: 1511.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_78_5692",
    x1: 650.518,
    y1: 992.132,
    x2: -474.017,
    y2: 1614.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_78_5692",
    x1: 638.411,
    y1: 942.674,
    x2: -499.743,
    y2: 1573.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_78_5692",
    x1: 616.686,
    y1: 903.168,
    x2: -504.678,
    y2: 1523.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_78_5692",
    x1: 610.912,
    y1: 911.048,
    x2: -504.323,
    y2: 1528.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_78_5692",
    x1: 598.323,
    y1: 836.369,
    x2: -541.199,
    y2: 1467.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_78_5692",
    x1: 543.05,
    y1: 777.145,
    x2: -567.745,
    y2: 1392.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_78_5692",
    x1: 517.08,
    y1: 709.289,
    x2: -590.845,
    y2: 1324.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_78_5692",
    x1: 587.397,
    y1: 822.814,
    x2: -555.094,
    y2: 1456.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_78_5692",
    x1: 687.947,
    y1: 1040.14,
    x2: -434.027,
    y2: 1660.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_78_5692",
    x1: 657.386,
    y1: 975.837,
    x2: -464.6,
    y2: 1596.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_78_5692",
    x1: 582.442,
    y1: 804.841,
    x2: -538.049,
    y2: 1425.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_78_5692",
    x1: 602.626,
    y1: 872.093,
    x2: -514.611,
    y2: 1490.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_78_5692",
    x1: 577.224,
    y1: 806.775,
    x2: -544.748,
    y2: 1427.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_78_5692",
    x1: 559.388,
    y1: 770.792,
    x2: -561.543,
    y2: 1391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_78_5692",
    x1: 667.183,
    y1: 1005.18,
    x2: -455.319,
    y2: 1626.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_78_5692",
    x1: 615.658,
    y1: 899.084,
    x2: -511.077,
    y2: 1522.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_78_5692",
    x1: 553.585,
    y1: 778.406,
    x2: -565.76,
    y2: 1397.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_78_5692",
    x1: 546.811,
    y1: 723.557,
    x2: -575.697,
    y2: 1344.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_78_5692",
    x1: 546.129,
    y1: 737.653,
    x2: -575.857,
    y2: 1358.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_78_5692",
    x1: 574.134,
    y1: 815.278,
    x2: -547.942,
    y2: 1436.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_78_5692",
    x1: 683.806,
    y1: 1047.63,
    x2: -438.708,
    y2: 1668.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_78_5692",
    x1: 667.861,
    y1: 1021.21,
    x2: -456.234,
    y2: 1643.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_78_5692",
    x1: 658.237,
    y1: 963.246,
    x2: -469.015,
    y2: 1586.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_78_5692",
    x1: 637.776,
    y1: 928.473,
    x2: -484.46,
    y2: 1549.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_78_5692",
    x1: 655.914,
    y1: 986.946,
    x2: -466.73,
    y2: 1608.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_78_5692",
    x1: 655.9,
    y1: 1001.19,
    x2: -467.278,
    y2: 1622.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_78_5692",
    x1: 600.597,
    y1: 842.118,
    x2: -522.221,
    y2: 1463.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_78_5692",
    x1: 700.821,
    y1: 1089.21,
    x2: -425.899,
    y2: 1712.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_78_5692",
    x1: 666.52,
    y1: 1027.34,
    x2: -447.535,
    y2: 1644.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_78_5692",
    x1: 674.332,
    y1: 1015.51,
    x2: -459.32,
    y2: 1643.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_78_5692",
    x1: 591.087,
    y1: 901.241,
    x2: -479.435,
    y2: 1510.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_78_5692",
    x1: 644.583,
    y1: 978.021,
    x2: -479.41,
    y2: 1599.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_78_5692",
    x1: 635.041,
    y1: 934.353,
    x2: -503.079,
    y2: 1564.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_78_5692",
    x1: 615.453,
    y1: 900.217,
    x2: -506.474,
    y2: 1521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_78_5692",
    x1: 609.801,
    y1: 907.44,
    x2: -505.374,
    y2: 1525.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_78_5692",
    x1: 600.117,
    y1: 841.357,
    x2: -539.142,
    y2: 1473.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_78_5692",
    x1: 550.358,
    y1: 790.583,
    x2: -560.472,
    y2: 1406.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_78_5692",
    x1: 527.471,
    y1: 731.326,
    x2: -580.463,
    y2: 1346.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_78_5692",
    x1: 590.512,
    y1: 829.697,
    x2: -551.54,
    y2: 1463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_78_5692",
    x1: 686.576,
    y1: 1051.04,
    x2: -440.164,
    y2: 1674.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_78_5692",
    x1: 678.072,
    y1: 1019.86,
    x2: -446.015,
    y2: 1641.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_78_5692",
    x1: 650.661,
    y1: 963.663,
    x2: -470.789,
    y2: 1584.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_78_5692",
    x1: 585.536,
    y1: 814.353,
    x2: -535.912,
    y2: 1434.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_78_5692",
    x1: 605.255,
    y1: 872.334,
    x2: -518.834,
    y2: 1494.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_78_5692",
    x1: 579.59,
    y1: 816.537,
    x2: -538.705,
    y2: 1435.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_78_5692",
    x1: 565.41,
    y1: 784.683,
    x2: -556.054,
    y2: 1405.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_78_5692",
    x1: 587.124,
    y1: 852.119,
    x2: -533.799,
    y2: 1472.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_78_5692",
    x1: 658.431,
    y1: 989.623,
    x2: -461.962,
    y2: 1609.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_78_5692",
    x1: 611.785,
    y1: 897.816,
    x2: -509.049,
    y2: 1517.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_78_5692",
    x1: 561.14,
    y1: 791.096,
    x2: -560.85,
    y2: 1411.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_78_5692",
    x1: 553.777,
    y1: 743.91,
    x2: -565.994,
    y2: 1363.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_78_5692",
    x1: 553.217,
    y1: 755.74,
    x2: -567.276,
    y2: 1376.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_78_5692",
    x1: 578.734,
    y1: 823.473,
    x2: -544.839,
    y2: 1445.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_78_5692",
    x1: 675.006,
    y1: 1026.06,
    x2: -450.139,
    y2: 1648.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_78_5692",
    x1: 658.436,
    y1: 1004.18,
    x2: -462.487,
    y2: 1624.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_78_5692",
    x1: 651.511,
    y1: 952.542,
    x2: -475.33,
    y2: 1576.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_78_5692",
    x1: 634.084,
    y1: 922.169,
    x2: -488.945,
    y2: 1543.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_78_5692",
    x1: 650.615,
    y1: 973.243,
    x2: -474.434,
    y2: 1595.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_78_5692",
    x1: 648.451,
    y1: 986.575,
    x2: -472.671,
    y2: 1606.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_78_5692",
    x1: 601.086,
    y1: 847.019,
    x2: -520.897,
    y2: 1467.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_78_5692",
    x1: 685.663,
    y1: 1034.99,
    x2: -469.077,
    y2: 1643.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_78_5692",
    x1: 678.026,
    y1: 1010.33,
    x2: -474.359,
    y2: 1617.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_78_5692",
    x1: 580.916,
    y1: 804.602,
    x2: -572.747,
    y2: 1412.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_78_5692",
    x1: 554.461,
    y1: 739.371,
    x2: -597.576,
    y2: 1346.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_78_5692",
    x1: 553.634,
    y1: 745.964,
    x2: -598.209,
    y2: 1352.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_78_5692",
    x1: 585.269,
    y1: 807.102,
    x2: -567.665,
    y2: 1414.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_78_5692",
    x1: 650.456,
    y1: 946.689,
    x2: -499.752,
    y2: 1552.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_78_5692",
    x1: 650.696,
    y1: 953.706,
    x2: -500.598,
    y2: 1559.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_78_5692",
    x1: 649.367,
    y1: 965.098,
    x2: -503.828,
    y2: 1572.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_78_5692",
    x1: 648.89,
    y1: 956.879,
    x2: -503.907,
    y2: 1563.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_78_5692",
    x1: 633.489,
    y1: 913.271,
    x2: -518.885,
    y2: 1520.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_78_5692",
    x1: 600.887,
    y1: 839.435,
    x2: -551.091,
    y2: 1446.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_78_5692",
    x1: 614.748,
    y1: 294.038,
    x2: -587.39,
    y2: 294.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_78_5692",
    x1: 614.749,
    y1: 299.157,
    x2: -587.388,
    y2: 299.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_78_5692",
    x1: 614.749,
    y1: 529.5,
    x2: -587.389,
    y2: 529.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_78_5692",
    x1: 614.748,
    y1: 390.829,
    x2: -587.39,
    y2: 390.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_78_5692",
    x1: 614.749,
    y1: 464.818,
    x2: -587.389,
    y2: 464.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_78_5692",
    x1: 614.749,
    y1: 509.491,
    x2: -587.388,
    y2: 509.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_78_5692",
    x1: 614.749,
    y1: 505.303,
    x2: -587.389,
    y2: 505.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_78_5692",
    x1: 614.749,
    y1: 578.826,
    x2: -587.388,
    y2: 578.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_78_5692",
    x1: 614.749,
    y1: 723.547,
    x2: -587.388,
    y2: 723.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_78_5692",
    x1: 614.748,
    y1: 815.685,
    x2: -587.389,
    y2: 815.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_78_5692",
    x1: 614.748,
    y1: 637.459,
    x2: -587.389,
    y2: 637.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_78_5692",
    x1: 614.75,
    y1: 265.187,
    x2: -587.393,
    y2: 265.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_78_5692",
    x1: 614.75,
    y1: 367.096,
    x2: -587.394,
    y2: 367.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_78_5692",
    x1: 614.748,
    y1: 614.658,
    x2: -587.39,
    y2: 614.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_78_5692",
    x1: 614.747,
    y1: 542.995,
    x2: -587.386,
    y2: 542.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_78_5692",
    x1: 614.747,
    y1: 633.271,
    x2: -587.386,
    y2: 633.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_78_5692",
    x1: 614.749,
    y1: 691.439,
    x2: -587.394,
    y2: 691.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_78_5692",
    x1: 614.747,
    y1: 335.453,
    x2: -586.932,
    y2: 335.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_78_5692",
    x1: 614.746,
    y1: 513.213,
    x2: -587.387,
    y2: 513.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_78_5692",
    x1: 614.749,
    y1: 734.716,
    x2: -587.389,
    y2: 734.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_78_5692",
    x1: 614.75,
    y1: 736.577,
    x2: -587.393,
    y2: 736.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_78_5692",
    x1: 614.752,
    y1: 643.974,
    x2: -587.391,
    y2: 643.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_78_5692",
    x1: 614.747,
    y1: 280.543,
    x2: -587.386,
    y2: 280.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_78_5692",
    x1: 614.749,
    y1: 368.027,
    x2: -587.389,
    y2: 368.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_78_5692",
    x1: 614.749,
    y1: 432.244,
    x2: -587.388,
    y2: 432.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_78_5692",
    x1: 614.748,
    y1: 373.146,
    x2: -587.39,
    y2: 373.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_78_5692",
    x1: 614.748,
    y1: 555.559,
    x2: -587.389,
    y2: 555.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_78_5692",
    x1: 614.749,
    y1: 358.255,
    x2: -587.389,
    y2: 358.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_78_5692",
    x1: 614.749,
    y1: 361.978,
    x2: -587.388,
    y2: 361.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_78_5692",
    x1: 614.75,
    y1: 532.292,
    x2: -587.388,
    y2: 532.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_78_5692",
    x1: 614.75,
    y1: 429.917,
    x2: -587.388,
    y2: 429.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_78_5692",
    x1: 614.749,
    y1: 484.362,
    x2: -587.389,
    y2: 484.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_78_5692",
    x1: 614.75,
    y1: 517.867,
    x2: -587.388,
    y2: 517.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_78_5692",
    x1: 614.75,
    y1: 514.61,
    x2: -587.388,
    y2: 514.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_78_5692",
    x1: 614.75,
    y1: 569.054,
    x2: -587.388,
    y2: 569.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_78_5692",
    x1: 614.749,
    y1: 676.083,
    x2: -587.388,
    y2: 676.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_78_5692",
    x1: 614.749,
    y1: 744.022,
    x2: -587.388,
    y2: 744.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_78_5692",
    x1: 614.749,
    y1: 612.331,
    x2: -587.388,
    y2: 612.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_78_5692",
    x1: 614.748,
    y1: 337.315,
    x2: -587.387,
    y2: 337.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_78_5692",
    x1: 614.749,
    y1: 412.235,
    x2: -587.386,
    y2: 412.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_78_5692",
    x1: 614.749,
    y1: 595.578,
    x2: -587.386,
    y2: 595.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_78_5692",
    x1: 614.749,
    y1: 542.53,
    x2: -587.386,
    y2: 542.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_78_5692",
    x1: 614.753,
    y1: 609.074,
    x2: -587.397,
    y2: 609.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_78_5692",
    x1: 614.751,
    y1: 651.885,
    x2: -587.392,
    y2: 651.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_78_5692",
    x1: 615.206,
    y1: 388.967,
    x2: -587.391,
    y2: 388.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_78_5692",
    x1: 614.748,
    y1: 520.193,
    x2: -586.933,
    y2: 520.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_78_5692",
    x1: 614.747,
    y1: 664.449,
    x2: -587.387,
    y2: 664.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_78_5692",
    x1: 614.749,
    y1: 684.459,
    x2: -587.386,
    y2: 684.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_78_5692",
    x1: 614.752,
    y1: 685.389,
    x2: -587.398,
    y2: 685.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_78_5692",
    x1: 614.752,
    y1: 616.984,
    x2: -587.391,
    y2: 616.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_78_5692",
    x1: 614.745,
    y1: 348.017,
    x2: -587.383,
    y2: 348.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_78_5692",
    x1: 614.749,
    y1: 412.7,
    x2: -587.386,
    y2: 412.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_78_5692",
    x1: 614.748,
    y1: 460.63,
    x2: -586.932,
    y2: 460.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_78_5692",
    x1: 614.752,
    y1: 416.888,
    x2: -587.392,
    y2: 416.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_78_5692",
    x1: 614.749,
    y1: 551.837,
    x2: -587.39,
    y2: 551.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_78_5692",
    x1: 614.749,
    y1: 381.522,
    x2: -587.389,
    y2: 381.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_78_5692",
    x1: 614.749,
    y1: 384.779,
    x2: -587.388,
    y2: 384.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_78_5692",
    x1: 614.75,
    y1: 533.688,
    x2: -587.388,
    y2: 533.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_78_5692",
    x1: 614.749,
    y1: 443.878,
    x2: -587.389,
    y2: 443.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_78_5692",
    x1: 614.748,
    y1: 491.808,
    x2: -587.389,
    y2: 491.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_78_5692",
    x1: 614.748,
    y1: 520.659,
    x2: -587.39,
    y2: 520.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_78_5692",
    x1: 614.749,
    y1: 517.867,
    x2: -587.389,
    y2: 517.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_78_5692",
    x1: 614.748,
    y1: 565.331,
    x2: -587.39,
    y2: 565.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_78_5692",
    x1: 614.749,
    y1: 658.865,
    x2: -587.389,
    y2: 658.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_78_5692",
    x1: 614.749,
    y1: 718.429,
    x2: -587.388,
    y2: 718.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_78_5692",
    x1: 614.749,
    y1: 603.024,
    x2: -587.388,
    y2: 603.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_78_5692",
    x1: 614.746,
    y1: 362.908,
    x2: -587.384,
    y2: 362.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_78_5692",
    x1: 614.746,
    y1: 428.521,
    x2: -587.384,
    y2: 428.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_78_5692",
    x1: 614.748,
    y1: 588.598,
    x2: -586.938,
    y2: 588.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_78_5692",
    x1: 615.199,
    y1: 542.064,
    x2: -587.385,
    y2: 542.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_78_5692",
    x1: 614.745,
    y1: 600.697,
    x2: -587.385,
    y2: 600.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_78_5692",
    x1: 614.752,
    y1: 637.924,
    x2: -587.396,
    y2: 637.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_78_5692",
    x1: 614.749,
    y1: 408.512,
    x2: -587.391,
    y2: 408.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_78_5692",
    x1: 614.753,
    y1: 522.986,
    x2: -587.395,
    y2: 522.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_78_5692",
    x1: 614.754,
    y1: 648.627,
    x2: -587.393,
    y2: 648.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_78_5692",
    x1: 614.749,
    y1: 666.31,
    x2: -587.39,
    y2: 666.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_78_5692",
    x1: 614.746,
    y1: 667.241,
    x2: -587.384,
    y2: 667.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_78_5692",
    x1: 614.749,
    y1: 607.212,
    x2: -587.391,
    y2: 607.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_78_5692",
    x1: 614.745,
    y1: 372.68,
    x2: -587.385,
    y2: 372.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_78_5692",
    x1: 614.751,
    y1: 428.986,
    x2: -587.397,
    y2: 428.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_78_5692",
    x1: 614.747,
    y1: 470.867,
    x2: -586.928,
    y2: 470.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_78_5692",
    x1: 614.751,
    y1: 432.709,
    x2: -586.937,
    y2: 432.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_78_5692",
    x1: 614.749,
    y1: 550.44,
    x2: -586.939,
    y2: 550.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_78_5692",
    x1: 614.748,
    y1: 345.691,
    x2: -587.389,
    y2: 345.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_78_5692",
    x1: 614.748,
    y1: 361.512,
    x2: -587.388,
    y2: 361.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_78_5692",
    x1: 614.748,
    y1: 600.697,
    x2: -587.389,
    y2: 600.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_78_5692",
    x1: 614.749,
    y1: 664.914,
    x2: -587.387,
    y2: 664.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_78_5692",
    x1: 614.748,
    y1: 667.241,
    x2: -587.388,
    y2: 667.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_78_5692",
    x1: 614.749,
    y1: 589.064,
    x2: -587.39,
    y2: 589.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_78_5692",
    x1: 614.749,
    y1: 428.521,
    x2: -587.391,
    y2: 428.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_78_5692",
    x1: 614.749,
    y1: 428.056,
    x2: -587.391,
    y2: 428.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_78_5692",
    x1: 614.75,
    y1: 433.64,
    x2: -587.389,
    y2: 433.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_78_5692",
    x1: 614.749,
    y1: 470.867,
    x2: -587.387,
    y2: 470.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_78_5692",
    x1: 614.749,
    y1: 551.371,
    x2: -587.387,
    y2: 551.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameSideL);
export default __webpack_public_path__ + "static/media/gameSideL.9725f6c58e9f316652f8f8cc653243df.svg";
export { ForwardRef as ReactComponent };